'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heart = exports.SignOut = exports.SignIn = exports.Telephone = exports.Move = exports.Mobile = exports.Microphone = exports.Fire = exports.Desktop = exports.Clipboard = exports.Bag = exports.GitHub = exports.Twitter = exports.EllipsisVertical = exports.EllipsisHorizontal = exports.Reload = exports.External = exports.Gift = exports.Cart = exports.CreditCard = exports.Info = exports.Alert = exports.Bell = exports.Unlock = exports.Lock = exports.Code = exports.Link = exports.Send = exports.Download = exports.Upload = exports.Compose = exports.Edit = exports.Reply = exports.Archive = exports.Inbox = exports.Import = exports.Export = exports.Location = exports.Activity = exports.Lightning = exports.Tag = exports.Bookmark = exports.Eye = exports.Print = exports.Calendar = exports.Book = exports.Portfolio = exports.Work = exports.FolderOpen = exports.Folder = exports.File = exports.Paperclip = exports.Trash = exports.User = exports.Home = exports.Mail = exports.Music = exports.Video = exports.Camera = exports.Photo = exports.Message = exports.Menu = exports.Clock = exports.Settings = exports.Options = exports.Flag = exports.Ban = exports.Volume = exports.Mute = exports.Eject = exports.End = exports.Start = exports.CaretLeft = exports.CaretBottom = exports.CaretRight = exports.CaretTop = exports.ArrowLeft = exports.ArrowBottom = exports.ArrowRight = exports.ArrowTop = exports.ChevronLeft = exports.ChevronBottom = exports.ChevronRight = exports.ChevronTop = exports.Checkmark = exports.Star = exports.Forwards = exports.Backwards = exports.Pause = exports.Play = exports.Minus = exports.Plus = exports.Close = exports.Search = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Search = exports.Search = function Search(_ref) {
  var className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 32 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 32 : _ref$height,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === undefined ? '6.25%' : _ref$strokeWidth,
      _ref$strokeLinejoin = _ref.strokeLinejoin,
      strokeLinejoin = _ref$strokeLinejoin === undefined ? 'round' : _ref$strokeLinejoin,
      _ref$strokeLinecap = _ref.strokeLinecap,
      strokeLinecap = _ref$strokeLinecap === undefined ? 'round' : _ref$strokeLinecap,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentcolor' : _ref$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-search',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('circle', {
    cx: 14,
    cy: 14,
    r: 12
  }), _react2.default.createElement('path', {
    d: 'M23 23 L30 30'
  }));
};

var Close = exports.Close = function Close(_ref2) {
  var className = _ref2.className,
      _ref2$width = _ref2.width,
      width = _ref2$width === undefined ? 32 : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === undefined ? 32 : _ref2$height,
      _ref2$strokeWidth = _ref2.strokeWidth,
      strokeWidth = _ref2$strokeWidth === undefined ? '6.25%' : _ref2$strokeWidth,
      _ref2$strokeLinejoin = _ref2.strokeLinejoin,
      strokeLinejoin = _ref2$strokeLinejoin === undefined ? 'round' : _ref2$strokeLinejoin,
      _ref2$strokeLinecap = _ref2.strokeLinecap,
      strokeLinecap = _ref2$strokeLinecap === undefined ? 'round' : _ref2$strokeLinecap,
      _ref2$color = _ref2.color,
      color = _ref2$color === undefined ? 'currentcolor' : _ref2$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-close',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 30 L30 2 M30 30 L2 2'
  }));
};

var Plus = exports.Plus = function Plus(_ref3) {
  var className = _ref3.className,
      _ref3$width = _ref3.width,
      width = _ref3$width === undefined ? 32 : _ref3$width,
      _ref3$height = _ref3.height,
      height = _ref3$height === undefined ? 32 : _ref3$height,
      _ref3$strokeWidth = _ref3.strokeWidth,
      strokeWidth = _ref3$strokeWidth === undefined ? '6.25%' : _ref3$strokeWidth,
      _ref3$strokeLinejoin = _ref3.strokeLinejoin,
      strokeLinejoin = _ref3$strokeLinejoin === undefined ? 'round' : _ref3$strokeLinejoin,
      _ref3$strokeLinecap = _ref3.strokeLinecap,
      strokeLinecap = _ref3$strokeLinecap === undefined ? 'round' : _ref3$strokeLinecap,
      _ref3$color = _ref3.color,
      color = _ref3$color === undefined ? 'currentcolor' : _ref3$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-plus',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M16 2 L16 30 M2 16 L30 16'
  }));
};

var Minus = exports.Minus = function Minus(_ref4) {
  var className = _ref4.className,
      _ref4$width = _ref4.width,
      width = _ref4$width === undefined ? 32 : _ref4$width,
      _ref4$height = _ref4.height,
      height = _ref4$height === undefined ? 32 : _ref4$height,
      _ref4$strokeWidth = _ref4.strokeWidth,
      strokeWidth = _ref4$strokeWidth === undefined ? '6.25%' : _ref4$strokeWidth,
      _ref4$strokeLinejoin = _ref4.strokeLinejoin,
      strokeLinejoin = _ref4$strokeLinejoin === undefined ? 'round' : _ref4$strokeLinejoin,
      _ref4$strokeLinecap = _ref4.strokeLinecap,
      strokeLinecap = _ref4$strokeLinecap === undefined ? 'round' : _ref4$strokeLinecap,
      _ref4$color = _ref4.color,
      color = _ref4$color === undefined ? 'currentcolor' : _ref4$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-minus',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 16 L30 16'
  }));
};

var Play = exports.Play = function Play(_ref5) {
  var className = _ref5.className,
      _ref5$width = _ref5.width,
      width = _ref5$width === undefined ? 32 : _ref5$width,
      _ref5$height = _ref5.height,
      height = _ref5$height === undefined ? 32 : _ref5$height,
      _ref5$strokeWidth = _ref5.strokeWidth,
      strokeWidth = _ref5$strokeWidth === undefined ? '6.25%' : _ref5$strokeWidth,
      _ref5$strokeLinejoin = _ref5.strokeLinejoin,
      strokeLinejoin = _ref5$strokeLinejoin === undefined ? 'round' : _ref5$strokeLinejoin,
      _ref5$strokeLinecap = _ref5.strokeLinecap,
      strokeLinecap = _ref5$strokeLinecap === undefined ? 'round' : _ref5$strokeLinecap,
      _ref5$color = _ref5.color,
      color = _ref5$color === undefined ? 'currentcolor' : _ref5$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-play',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M10 2 L10 30 24 16 Z'
  }));
};

var Pause = exports.Pause = function Pause(_ref6) {
  var className = _ref6.className,
      _ref6$width = _ref6.width,
      width = _ref6$width === undefined ? 32 : _ref6$width,
      _ref6$height = _ref6.height,
      height = _ref6$height === undefined ? 32 : _ref6$height,
      _ref6$strokeWidth = _ref6.strokeWidth,
      strokeWidth = _ref6$strokeWidth === undefined ? '6.25%' : _ref6$strokeWidth,
      _ref6$strokeLinejoin = _ref6.strokeLinejoin,
      strokeLinejoin = _ref6$strokeLinejoin === undefined ? 'round' : _ref6$strokeLinejoin,
      _ref6$strokeLinecap = _ref6.strokeLinecap,
      strokeLinecap = _ref6$strokeLinecap === undefined ? 'round' : _ref6$strokeLinecap,
      _ref6$color = _ref6.color,
      color = _ref6$color === undefined ? 'currentcolor' : _ref6$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-pause',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M23 2 L23 30 M9 2 L9 30'
  }));
};

var Backwards = exports.Backwards = function Backwards(_ref7) {
  var className = _ref7.className,
      _ref7$width = _ref7.width,
      width = _ref7$width === undefined ? 32 : _ref7$width,
      _ref7$height = _ref7.height,
      height = _ref7$height === undefined ? 32 : _ref7$height,
      _ref7$strokeWidth = _ref7.strokeWidth,
      strokeWidth = _ref7$strokeWidth === undefined ? '6.25%' : _ref7$strokeWidth,
      _ref7$strokeLinejoin = _ref7.strokeLinejoin,
      strokeLinejoin = _ref7$strokeLinejoin === undefined ? 'round' : _ref7$strokeLinejoin,
      _ref7$strokeLinecap = _ref7.strokeLinecap,
      strokeLinecap = _ref7$strokeLinecap === undefined ? 'round' : _ref7$strokeLinecap,
      _ref7$color = _ref7.color,
      color = _ref7$color === undefined ? 'currentcolor' : _ref7$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-backwards',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M16 2 L2 16 16 30 16 16 30 30 30 2 16 16 Z'
  }));
};

var Forwards = exports.Forwards = function Forwards(_ref8) {
  var className = _ref8.className,
      _ref8$width = _ref8.width,
      width = _ref8$width === undefined ? 32 : _ref8$width,
      _ref8$height = _ref8.height,
      height = _ref8$height === undefined ? 32 : _ref8$height,
      _ref8$strokeWidth = _ref8.strokeWidth,
      strokeWidth = _ref8$strokeWidth === undefined ? '6.25%' : _ref8$strokeWidth,
      _ref8$strokeLinejoin = _ref8.strokeLinejoin,
      strokeLinejoin = _ref8$strokeLinejoin === undefined ? 'round' : _ref8$strokeLinejoin,
      _ref8$strokeLinecap = _ref8.strokeLinecap,
      strokeLinecap = _ref8$strokeLinecap === undefined ? 'round' : _ref8$strokeLinecap,
      _ref8$color = _ref8.color,
      color = _ref8$color === undefined ? 'currentcolor' : _ref8$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-forwards',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M16 2 L30 16 16 30 16 16 2 30 2 2 16 16 Z'
  }));
};

var Star = exports.Star = function Star(_ref9) {
  var className = _ref9.className,
      _ref9$width = _ref9.width,
      width = _ref9$width === undefined ? 32 : _ref9$width,
      _ref9$height = _ref9.height,
      height = _ref9$height === undefined ? 32 : _ref9$height,
      _ref9$strokeWidth = _ref9.strokeWidth,
      strokeWidth = _ref9$strokeWidth === undefined ? '6.25%' : _ref9$strokeWidth,
      _ref9$strokeLinejoin = _ref9.strokeLinejoin,
      strokeLinejoin = _ref9$strokeLinejoin === undefined ? 'round' : _ref9$strokeLinejoin,
      _ref9$strokeLinecap = _ref9.strokeLinecap,
      strokeLinecap = _ref9$strokeLinecap === undefined ? 'round' : _ref9$strokeLinecap,
      _ref9$color = _ref9.color,
      color = _ref9$color === undefined ? 'currentcolor' : _ref9$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-star',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M16 2 L20 12 30 12 22 19 25 30 16 23 7 30 10 19 2 12 12 12 Z'
  }));
};

var Checkmark = exports.Checkmark = function Checkmark(_ref10) {
  var className = _ref10.className,
      _ref10$width = _ref10.width,
      width = _ref10$width === undefined ? 32 : _ref10$width,
      _ref10$height = _ref10.height,
      height = _ref10$height === undefined ? 32 : _ref10$height,
      _ref10$strokeWidth = _ref10.strokeWidth,
      strokeWidth = _ref10$strokeWidth === undefined ? '6.25%' : _ref10$strokeWidth,
      _ref10$strokeLinejoin = _ref10.strokeLinejoin,
      strokeLinejoin = _ref10$strokeLinejoin === undefined ? 'round' : _ref10$strokeLinejoin,
      _ref10$strokeLinecap = _ref10.strokeLinecap,
      strokeLinecap = _ref10$strokeLinecap === undefined ? 'round' : _ref10$strokeLinecap,
      _ref10$color = _ref10.color,
      color = _ref10$color === undefined ? 'currentcolor' : _ref10$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-checkmark',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 20 L12 28 30 4'
  }));
};

var ChevronTop = exports.ChevronTop = function ChevronTop(_ref11) {
  var className = _ref11.className,
      _ref11$width = _ref11.width,
      width = _ref11$width === undefined ? 32 : _ref11$width,
      _ref11$height = _ref11.height,
      height = _ref11$height === undefined ? 32 : _ref11$height,
      _ref11$strokeWidth = _ref11.strokeWidth,
      strokeWidth = _ref11$strokeWidth === undefined ? '6.25%' : _ref11$strokeWidth,
      _ref11$strokeLinejoin = _ref11.strokeLinejoin,
      strokeLinejoin = _ref11$strokeLinejoin === undefined ? 'round' : _ref11$strokeLinejoin,
      _ref11$strokeLinecap = _ref11.strokeLinecap,
      strokeLinecap = _ref11$strokeLinecap === undefined ? 'round' : _ref11$strokeLinecap,
      _ref11$color = _ref11.color,
      color = _ref11$color === undefined ? 'currentcolor' : _ref11$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-chevron-top',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M30 20 L16 8 2 20'
  }));
};

var ChevronRight = exports.ChevronRight = function ChevronRight(_ref12) {
  var className = _ref12.className,
      _ref12$width = _ref12.width,
      width = _ref12$width === undefined ? 32 : _ref12$width,
      _ref12$height = _ref12.height,
      height = _ref12$height === undefined ? 32 : _ref12$height,
      _ref12$strokeWidth = _ref12.strokeWidth,
      strokeWidth = _ref12$strokeWidth === undefined ? '6.25%' : _ref12$strokeWidth,
      _ref12$strokeLinejoin = _ref12.strokeLinejoin,
      strokeLinejoin = _ref12$strokeLinejoin === undefined ? 'round' : _ref12$strokeLinejoin,
      _ref12$strokeLinecap = _ref12.strokeLinecap,
      strokeLinecap = _ref12$strokeLinecap === undefined ? 'round' : _ref12$strokeLinecap,
      _ref12$color = _ref12.color,
      color = _ref12$color === undefined ? 'currentcolor' : _ref12$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-chevron-right',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M12 30 L24 16 12 2'
  }));
};

var ChevronBottom = exports.ChevronBottom = function ChevronBottom(_ref13) {
  var className = _ref13.className,
      _ref13$width = _ref13.width,
      width = _ref13$width === undefined ? 32 : _ref13$width,
      _ref13$height = _ref13.height,
      height = _ref13$height === undefined ? 32 : _ref13$height,
      _ref13$strokeWidth = _ref13.strokeWidth,
      strokeWidth = _ref13$strokeWidth === undefined ? '6.25%' : _ref13$strokeWidth,
      _ref13$strokeLinejoin = _ref13.strokeLinejoin,
      strokeLinejoin = _ref13$strokeLinejoin === undefined ? 'round' : _ref13$strokeLinejoin,
      _ref13$strokeLinecap = _ref13.strokeLinecap,
      strokeLinecap = _ref13$strokeLinecap === undefined ? 'round' : _ref13$strokeLinecap,
      _ref13$color = _ref13.color,
      color = _ref13$color === undefined ? 'currentcolor' : _ref13$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-chevron-bottom',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M30 12 L16 24 2 12'
  }));
};

var ChevronLeft = exports.ChevronLeft = function ChevronLeft(_ref14) {
  var className = _ref14.className,
      _ref14$width = _ref14.width,
      width = _ref14$width === undefined ? 32 : _ref14$width,
      _ref14$height = _ref14.height,
      height = _ref14$height === undefined ? 32 : _ref14$height,
      _ref14$strokeWidth = _ref14.strokeWidth,
      strokeWidth = _ref14$strokeWidth === undefined ? '6.25%' : _ref14$strokeWidth,
      _ref14$strokeLinejoin = _ref14.strokeLinejoin,
      strokeLinejoin = _ref14$strokeLinejoin === undefined ? 'round' : _ref14$strokeLinejoin,
      _ref14$strokeLinecap = _ref14.strokeLinecap,
      strokeLinecap = _ref14$strokeLinecap === undefined ? 'round' : _ref14$strokeLinecap,
      _ref14$color = _ref14.color,
      color = _ref14$color === undefined ? 'currentcolor' : _ref14$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-chevron-left',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M20 30 L8 16 20 2'
  }));
};

var ArrowTop = exports.ArrowTop = function ArrowTop(_ref15) {
  var className = _ref15.className,
      _ref15$width = _ref15.width,
      width = _ref15$width === undefined ? 32 : _ref15$width,
      _ref15$height = _ref15.height,
      height = _ref15$height === undefined ? 32 : _ref15$height,
      _ref15$strokeWidth = _ref15.strokeWidth,
      strokeWidth = _ref15$strokeWidth === undefined ? '6.25%' : _ref15$strokeWidth,
      _ref15$strokeLinejoin = _ref15.strokeLinejoin,
      strokeLinejoin = _ref15$strokeLinejoin === undefined ? 'round' : _ref15$strokeLinejoin,
      _ref15$strokeLinecap = _ref15.strokeLinecap,
      strokeLinecap = _ref15$strokeLinecap === undefined ? 'round' : _ref15$strokeLinecap,
      _ref15$color = _ref15.color,
      color = _ref15$color === undefined ? 'currentcolor' : _ref15$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-arrow-top',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M6 10 L16 2 26 10 M16 2 L16 30'
  }));
};

var ArrowRight = exports.ArrowRight = function ArrowRight(_ref16) {
  var className = _ref16.className,
      _ref16$width = _ref16.width,
      width = _ref16$width === undefined ? 32 : _ref16$width,
      _ref16$height = _ref16.height,
      height = _ref16$height === undefined ? 32 : _ref16$height,
      _ref16$strokeWidth = _ref16.strokeWidth,
      strokeWidth = _ref16$strokeWidth === undefined ? '6.25%' : _ref16$strokeWidth,
      _ref16$strokeLinejoin = _ref16.strokeLinejoin,
      strokeLinejoin = _ref16$strokeLinejoin === undefined ? 'round' : _ref16$strokeLinejoin,
      _ref16$strokeLinecap = _ref16.strokeLinecap,
      strokeLinecap = _ref16$strokeLinecap === undefined ? 'round' : _ref16$strokeLinecap,
      _ref16$color = _ref16.color,
      color = _ref16$color === undefined ? 'currentcolor' : _ref16$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-arrow-right',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M22 6 L30 16 22 26 M30 16 L2 16'
  }));
};

var ArrowBottom = exports.ArrowBottom = function ArrowBottom(_ref17) {
  var className = _ref17.className,
      _ref17$width = _ref17.width,
      width = _ref17$width === undefined ? 32 : _ref17$width,
      _ref17$height = _ref17.height,
      height = _ref17$height === undefined ? 32 : _ref17$height,
      _ref17$strokeWidth = _ref17.strokeWidth,
      strokeWidth = _ref17$strokeWidth === undefined ? '6.25%' : _ref17$strokeWidth,
      _ref17$strokeLinejoin = _ref17.strokeLinejoin,
      strokeLinejoin = _ref17$strokeLinejoin === undefined ? 'round' : _ref17$strokeLinejoin,
      _ref17$strokeLinecap = _ref17.strokeLinecap,
      strokeLinecap = _ref17$strokeLinecap === undefined ? 'round' : _ref17$strokeLinecap,
      _ref17$color = _ref17.color,
      color = _ref17$color === undefined ? 'currentcolor' : _ref17$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-arrow-bottom',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M6 22 L16 30 26 22 M16 30 L16 2'
  }));
};

var ArrowLeft = exports.ArrowLeft = function ArrowLeft(_ref18) {
  var className = _ref18.className,
      _ref18$width = _ref18.width,
      width = _ref18$width === undefined ? 32 : _ref18$width,
      _ref18$height = _ref18.height,
      height = _ref18$height === undefined ? 32 : _ref18$height,
      _ref18$strokeWidth = _ref18.strokeWidth,
      strokeWidth = _ref18$strokeWidth === undefined ? '6.25%' : _ref18$strokeWidth,
      _ref18$strokeLinejoin = _ref18.strokeLinejoin,
      strokeLinejoin = _ref18$strokeLinejoin === undefined ? 'round' : _ref18$strokeLinejoin,
      _ref18$strokeLinecap = _ref18.strokeLinecap,
      strokeLinecap = _ref18$strokeLinecap === undefined ? 'round' : _ref18$strokeLinecap,
      _ref18$color = _ref18.color,
      color = _ref18$color === undefined ? 'currentcolor' : _ref18$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-arrow-left',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M10 6 L2 16 10 26 M2 16 L30 16'
  }));
};

var CaretTop = exports.CaretTop = function CaretTop(_ref19) {
  var className = _ref19.className,
      _ref19$width = _ref19.width,
      width = _ref19$width === undefined ? 32 : _ref19$width,
      _ref19$height = _ref19.height,
      height = _ref19$height === undefined ? 32 : _ref19$height,
      _ref19$strokeWidth = _ref19.strokeWidth,
      strokeWidth = _ref19$strokeWidth === undefined ? '6.25%' : _ref19$strokeWidth,
      _ref19$strokeLinejoin = _ref19.strokeLinejoin,
      strokeLinejoin = _ref19$strokeLinejoin === undefined ? 'round' : _ref19$strokeLinejoin,
      _ref19$strokeLinecap = _ref19.strokeLinecap,
      strokeLinecap = _ref19$strokeLinecap === undefined ? 'round' : _ref19$strokeLinecap,
      _ref19$color = _ref19.color,
      color = _ref19$color === undefined ? 'currentcolor' : _ref19$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-caret-top',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M30 22 L16 6 2 22 Z'
  }));
};

var CaretRight = exports.CaretRight = function CaretRight(_ref20) {
  var className = _ref20.className,
      _ref20$width = _ref20.width,
      width = _ref20$width === undefined ? 32 : _ref20$width,
      _ref20$height = _ref20.height,
      height = _ref20$height === undefined ? 32 : _ref20$height,
      _ref20$strokeWidth = _ref20.strokeWidth,
      strokeWidth = _ref20$strokeWidth === undefined ? '6.25%' : _ref20$strokeWidth,
      _ref20$strokeLinejoin = _ref20.strokeLinejoin,
      strokeLinejoin = _ref20$strokeLinejoin === undefined ? 'round' : _ref20$strokeLinejoin,
      _ref20$strokeLinecap = _ref20.strokeLinecap,
      strokeLinecap = _ref20$strokeLinecap === undefined ? 'round' : _ref20$strokeLinecap,
      _ref20$color = _ref20.color,
      color = _ref20$color === undefined ? 'currentcolor' : _ref20$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-caret-right',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M10 30 L26 16 10 2 Z'
  }));
};

var CaretBottom = exports.CaretBottom = function CaretBottom(_ref21) {
  var className = _ref21.className,
      _ref21$width = _ref21.width,
      width = _ref21$width === undefined ? 32 : _ref21$width,
      _ref21$height = _ref21.height,
      height = _ref21$height === undefined ? 32 : _ref21$height,
      _ref21$strokeWidth = _ref21.strokeWidth,
      strokeWidth = _ref21$strokeWidth === undefined ? '6.25%' : _ref21$strokeWidth,
      _ref21$strokeLinejoin = _ref21.strokeLinejoin,
      strokeLinejoin = _ref21$strokeLinejoin === undefined ? 'round' : _ref21$strokeLinejoin,
      _ref21$strokeLinecap = _ref21.strokeLinecap,
      strokeLinecap = _ref21$strokeLinecap === undefined ? 'round' : _ref21$strokeLinecap,
      _ref21$color = _ref21.color,
      color = _ref21$color === undefined ? 'currentcolor' : _ref21$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-caret-bottom',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M30 10 L16 26 2 10 Z'
  }));
};

var CaretLeft = exports.CaretLeft = function CaretLeft(_ref22) {
  var className = _ref22.className,
      _ref22$width = _ref22.width,
      width = _ref22$width === undefined ? 32 : _ref22$width,
      _ref22$height = _ref22.height,
      height = _ref22$height === undefined ? 32 : _ref22$height,
      _ref22$strokeWidth = _ref22.strokeWidth,
      strokeWidth = _ref22$strokeWidth === undefined ? '6.25%' : _ref22$strokeWidth,
      _ref22$strokeLinejoin = _ref22.strokeLinejoin,
      strokeLinejoin = _ref22$strokeLinejoin === undefined ? 'round' : _ref22$strokeLinejoin,
      _ref22$strokeLinecap = _ref22.strokeLinecap,
      strokeLinecap = _ref22$strokeLinecap === undefined ? 'round' : _ref22$strokeLinecap,
      _ref22$color = _ref22.color,
      color = _ref22$color === undefined ? 'currentcolor' : _ref22$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-caret-left',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M22 30 L6 16 22 2 Z'
  }));
};

var Start = exports.Start = function Start(_ref23) {
  var className = _ref23.className,
      _ref23$width = _ref23.width,
      width = _ref23$width === undefined ? 32 : _ref23$width,
      _ref23$height = _ref23.height,
      height = _ref23$height === undefined ? 32 : _ref23$height,
      _ref23$strokeWidth = _ref23.strokeWidth,
      strokeWidth = _ref23$strokeWidth === undefined ? '6.25%' : _ref23$strokeWidth,
      _ref23$strokeLinejoin = _ref23.strokeLinejoin,
      strokeLinejoin = _ref23$strokeLinejoin === undefined ? 'round' : _ref23$strokeLinejoin,
      _ref23$strokeLinecap = _ref23.strokeLinecap,
      strokeLinecap = _ref23$strokeLinecap === undefined ? 'round' : _ref23$strokeLinecap,
      _ref23$color = _ref23.color,
      color = _ref23$color === undefined ? 'currentcolor' : _ref23$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-start',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M8 2 L8 16 22 2 22 30 8 16 8 30'
  }));
};

var End = exports.End = function End(_ref24) {
  var className = _ref24.className,
      _ref24$width = _ref24.width,
      width = _ref24$width === undefined ? 32 : _ref24$width,
      _ref24$height = _ref24.height,
      height = _ref24$height === undefined ? 32 : _ref24$height,
      _ref24$strokeWidth = _ref24.strokeWidth,
      strokeWidth = _ref24$strokeWidth === undefined ? '6.25%' : _ref24$strokeWidth,
      _ref24$strokeLinejoin = _ref24.strokeLinejoin,
      strokeLinejoin = _ref24$strokeLinejoin === undefined ? 'round' : _ref24$strokeLinejoin,
      _ref24$strokeLinecap = _ref24.strokeLinecap,
      strokeLinecap = _ref24$strokeLinecap === undefined ? 'round' : _ref24$strokeLinecap,
      _ref24$color = _ref24.color,
      color = _ref24$color === undefined ? 'currentcolor' : _ref24$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-end',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M24 2 L24 16 10 2 10 30 24 16 24 30'
  }));
};

var Eject = exports.Eject = function Eject(_ref25) {
  var className = _ref25.className,
      _ref25$width = _ref25.width,
      width = _ref25$width === undefined ? 32 : _ref25$width,
      _ref25$height = _ref25.height,
      height = _ref25$height === undefined ? 32 : _ref25$height,
      _ref25$strokeWidth = _ref25.strokeWidth,
      strokeWidth = _ref25$strokeWidth === undefined ? '6.25%' : _ref25$strokeWidth,
      _ref25$strokeLinejoin = _ref25.strokeLinejoin,
      strokeLinejoin = _ref25$strokeLinejoin === undefined ? 'round' : _ref25$strokeLinejoin,
      _ref25$strokeLinecap = _ref25.strokeLinecap,
      strokeLinecap = _ref25$strokeLinecap === undefined ? 'round' : _ref25$strokeLinecap,
      _ref25$color = _ref25.color,
      color = _ref25$color === undefined ? 'currentcolor' : _ref25$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-eject',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M30 18 L16 5 2 18 Z M30 18 M2 25 L30 25'
  }));
};

var Mute = exports.Mute = function Mute(_ref26) {
  var className = _ref26.className,
      _ref26$width = _ref26.width,
      width = _ref26$width === undefined ? 32 : _ref26$width,
      _ref26$height = _ref26.height,
      height = _ref26$height === undefined ? 32 : _ref26$height,
      _ref26$strokeWidth = _ref26.strokeWidth,
      strokeWidth = _ref26$strokeWidth === undefined ? '6.25%' : _ref26$strokeWidth,
      _ref26$strokeLinejoin = _ref26.strokeLinejoin,
      strokeLinejoin = _ref26$strokeLinejoin === undefined ? 'round' : _ref26$strokeLinejoin,
      _ref26$strokeLinecap = _ref26.strokeLinecap,
      strokeLinecap = _ref26$strokeLinecap === undefined ? 'round' : _ref26$strokeLinecap,
      _ref26$color = _ref26.color,
      color = _ref26$color === undefined ? 'currentcolor' : _ref26$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-mute',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M20 16 C20 8 15 2 15 2 L8 10 2 10 2 22 8 22 15 30 C15 30 20 24 20 16 Z'
  }));
};

var Volume = exports.Volume = function Volume(_ref27) {
  var className = _ref27.className,
      _ref27$width = _ref27.width,
      width = _ref27$width === undefined ? 32 : _ref27$width,
      _ref27$height = _ref27.height,
      height = _ref27$height === undefined ? 32 : _ref27$height,
      _ref27$strokeWidth = _ref27.strokeWidth,
      strokeWidth = _ref27$strokeWidth === undefined ? '6.25%' : _ref27$strokeWidth,
      _ref27$strokeLinejoin = _ref27.strokeLinejoin,
      strokeLinejoin = _ref27$strokeLinejoin === undefined ? 'round' : _ref27$strokeLinejoin,
      _ref27$strokeLinecap = _ref27.strokeLinecap,
      strokeLinecap = _ref27$strokeLinecap === undefined ? 'round' : _ref27$strokeLinecap,
      _ref27$color = _ref27.color,
      color = _ref27$color === undefined ? 'currentcolor' : _ref27$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-volume',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M20 16 C20 8 15 2 15 2 L8 10 2 10 2 22 8 22 15 30 C15 30 20 24 20 16 Z M21 2 C21 2 25 6 25 16 25 26 21 30 21 30 M27 4 C27 4 30 8 30 16 30 24 27 28 27 28'
  }));
};

var Ban = exports.Ban = function Ban(_ref28) {
  var className = _ref28.className,
      _ref28$width = _ref28.width,
      width = _ref28$width === undefined ? 32 : _ref28$width,
      _ref28$height = _ref28.height,
      height = _ref28$height === undefined ? 32 : _ref28$height,
      _ref28$strokeWidth = _ref28.strokeWidth,
      strokeWidth = _ref28$strokeWidth === undefined ? '6.25%' : _ref28$strokeWidth,
      _ref28$strokeLinejoin = _ref28.strokeLinejoin,
      strokeLinejoin = _ref28$strokeLinejoin === undefined ? 'round' : _ref28$strokeLinejoin,
      _ref28$strokeLinecap = _ref28.strokeLinecap,
      strokeLinecap = _ref28$strokeLinecap === undefined ? 'round' : _ref28$strokeLinecap,
      _ref28$color = _ref28.color,
      color = _ref28$color === undefined ? 'currentcolor' : _ref28$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-ban',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '14'
  }), _react2.default.createElement('path', {
    d: 'M6 6 L26 26'
  }));
};

var Flag = exports.Flag = function Flag(_ref29) {
  var className = _ref29.className,
      _ref29$width = _ref29.width,
      width = _ref29$width === undefined ? 32 : _ref29$width,
      _ref29$height = _ref29.height,
      height = _ref29$height === undefined ? 32 : _ref29$height,
      _ref29$strokeWidth = _ref29.strokeWidth,
      strokeWidth = _ref29$strokeWidth === undefined ? '6.25%' : _ref29$strokeWidth,
      _ref29$strokeLinejoin = _ref29.strokeLinejoin,
      strokeLinejoin = _ref29$strokeLinejoin === undefined ? 'round' : _ref29$strokeLinejoin,
      _ref29$strokeLinecap = _ref29.strokeLinecap,
      strokeLinecap = _ref29$strokeLinecap === undefined ? 'round' : _ref29$strokeLinecap,
      _ref29$color = _ref29.color,
      color = _ref29$color === undefined ? 'currentcolor' : _ref29$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-flag',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M6 2 L6 30 M6 6 L26 6 20 12 26 18 6 18'
  }));
};

var Options = exports.Options = function Options(_ref30) {
  var className = _ref30.className,
      _ref30$width = _ref30.width,
      width = _ref30$width === undefined ? 32 : _ref30$width,
      _ref30$height = _ref30.height,
      height = _ref30$height === undefined ? 32 : _ref30$height,
      _ref30$strokeWidth = _ref30.strokeWidth,
      strokeWidth = _ref30$strokeWidth === undefined ? '6.25%' : _ref30$strokeWidth,
      _ref30$strokeLinejoin = _ref30.strokeLinejoin,
      strokeLinejoin = _ref30$strokeLinejoin === undefined ? 'round' : _ref30$strokeLinejoin,
      _ref30$strokeLinecap = _ref30.strokeLinecap,
      strokeLinecap = _ref30$strokeLinecap === undefined ? 'round' : _ref30$strokeLinecap,
      _ref30$color = _ref30.color,
      color = _ref30$color === undefined ? 'currentcolor' : _ref30$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-options',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M28 6 L4 6 M28 16 L4 16 M28 26 L4 26 M24 3 L24 9 M8 13 L8 19 M20 23 L20 29'
  }));
};

var Settings = exports.Settings = function Settings(_ref31) {
  var className = _ref31.className,
      _ref31$width = _ref31.width,
      width = _ref31$width === undefined ? 32 : _ref31$width,
      _ref31$height = _ref31.height,
      height = _ref31$height === undefined ? 32 : _ref31$height,
      _ref31$strokeWidth = _ref31.strokeWidth,
      strokeWidth = _ref31$strokeWidth === undefined ? '6.25%' : _ref31$strokeWidth,
      _ref31$strokeLinejoin = _ref31.strokeLinejoin,
      strokeLinejoin = _ref31$strokeLinejoin === undefined ? 'round' : _ref31$strokeLinejoin,
      _ref31$strokeLinecap = _ref31.strokeLinecap,
      strokeLinecap = _ref31$strokeLinecap === undefined ? 'round' : _ref31$strokeLinecap,
      _ref31$color = _ref31.color,
      color = _ref31$color === undefined ? 'currentcolor' : _ref31$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-settings',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M13 2 L13 6 11 7 8 4 4 8 7 11 6 13 2 13 2 19 6 19 7 21 4 24 8 28 11 25 13 26 13 30 19 30 19 26 21 25 24 28 28 24 25 21 26 19 30 19 30 13 26 13 25 11 28 8 24 4 21 7 19 6 19 2 Z'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '4'
  }));
};

var Clock = exports.Clock = function Clock(_ref32) {
  var className = _ref32.className,
      _ref32$width = _ref32.width,
      width = _ref32$width === undefined ? 32 : _ref32$width,
      _ref32$height = _ref32.height,
      height = _ref32$height === undefined ? 32 : _ref32$height,
      _ref32$strokeWidth = _ref32.strokeWidth,
      strokeWidth = _ref32$strokeWidth === undefined ? '6.25%' : _ref32$strokeWidth,
      _ref32$strokeLinejoin = _ref32.strokeLinejoin,
      strokeLinejoin = _ref32$strokeLinejoin === undefined ? 'round' : _ref32$strokeLinejoin,
      _ref32$strokeLinecap = _ref32.strokeLinecap,
      strokeLinecap = _ref32$strokeLinecap === undefined ? 'round' : _ref32$strokeLinecap,
      _ref32$color = _ref32.color,
      color = _ref32$color === undefined ? 'currentcolor' : _ref32$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-clock',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '14'
  }), _react2.default.createElement('path', {
    d: 'M16 8 L16 16 20 20'
  }));
};

var Menu = exports.Menu = function Menu(_ref33) {
  var className = _ref33.className,
      _ref33$width = _ref33.width,
      width = _ref33$width === undefined ? 32 : _ref33$width,
      _ref33$height = _ref33.height,
      height = _ref33$height === undefined ? 32 : _ref33$height,
      _ref33$strokeWidth = _ref33.strokeWidth,
      strokeWidth = _ref33$strokeWidth === undefined ? '6.25%' : _ref33$strokeWidth,
      _ref33$strokeLinejoin = _ref33.strokeLinejoin,
      strokeLinejoin = _ref33$strokeLinejoin === undefined ? 'round' : _ref33$strokeLinejoin,
      _ref33$strokeLinecap = _ref33.strokeLinecap,
      strokeLinecap = _ref33$strokeLinecap === undefined ? 'round' : _ref33$strokeLinecap,
      _ref33$color = _ref33.color,
      color = _ref33$color === undefined ? 'currentcolor' : _ref33$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-menu',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M4 8 L28 8 M4 16 L28 16 M4 24 L28 24'
  }));
};

var Message = exports.Message = function Message(_ref34) {
  var className = _ref34.className,
      _ref34$width = _ref34.width,
      width = _ref34$width === undefined ? 32 : _ref34$width,
      _ref34$height = _ref34.height,
      height = _ref34$height === undefined ? 32 : _ref34$height,
      _ref34$strokeWidth = _ref34.strokeWidth,
      strokeWidth = _ref34$strokeWidth === undefined ? '6.25%' : _ref34$strokeWidth,
      _ref34$strokeLinejoin = _ref34.strokeLinejoin,
      strokeLinejoin = _ref34$strokeLinejoin === undefined ? 'round' : _ref34$strokeLinejoin,
      _ref34$strokeLinecap = _ref34.strokeLinecap,
      strokeLinecap = _ref34$strokeLinecap === undefined ? 'round' : _ref34$strokeLinecap,
      _ref34$color = _ref34.color,
      color = _ref34$color === undefined ? 'currentcolor' : _ref34$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-msg',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 4 L30 4 30 22 16 22 8 29 8 22 2 22 Z'
  }));
};

var Photo = exports.Photo = function Photo(_ref35) {
  var className = _ref35.className,
      _ref35$width = _ref35.width,
      width = _ref35$width === undefined ? 32 : _ref35$width,
      _ref35$height = _ref35.height,
      height = _ref35$height === undefined ? 32 : _ref35$height,
      _ref35$strokeWidth = _ref35.strokeWidth,
      strokeWidth = _ref35$strokeWidth === undefined ? '6.25%' : _ref35$strokeWidth,
      _ref35$strokeLinejoin = _ref35.strokeLinejoin,
      strokeLinejoin = _ref35$strokeLinejoin === undefined ? 'round' : _ref35$strokeLinejoin,
      _ref35$strokeLinecap = _ref35.strokeLinecap,
      strokeLinecap = _ref35$strokeLinecap === undefined ? 'round' : _ref35$strokeLinecap,
      _ref35$color = _ref35.color,
      color = _ref35$color === undefined ? 'currentcolor' : _ref35$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-photo',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M20 24 L12 16 2 26 2 2 30 2 30 24 M16 20 L22 14 30 22 30 30 2 30 2 24'
  }), _react2.default.createElement('circle', {
    cx: '10',
    cy: '9',
    r: '3'
  }));
};

var Camera = exports.Camera = function Camera(_ref36) {
  var className = _ref36.className,
      _ref36$width = _ref36.width,
      width = _ref36$width === undefined ? 32 : _ref36$width,
      _ref36$height = _ref36.height,
      height = _ref36$height === undefined ? 32 : _ref36$height,
      _ref36$strokeWidth = _ref36.strokeWidth,
      strokeWidth = _ref36$strokeWidth === undefined ? '6.25%' : _ref36$strokeWidth,
      _ref36$strokeLinejoin = _ref36.strokeLinejoin,
      strokeLinejoin = _ref36$strokeLinejoin === undefined ? 'round' : _ref36$strokeLinejoin,
      _ref36$strokeLinecap = _ref36.strokeLinecap,
      strokeLinecap = _ref36$strokeLinecap === undefined ? 'round' : _ref36$strokeLinecap,
      _ref36$color = _ref36.color,
      color = _ref36$color === undefined ? 'currentcolor' : _ref36$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-camera',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 8 L 9 8 12 4 20 4 23 8 30 8 30 26 2 26 Z'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '5'
  }));
};

var Video = exports.Video = function Video(_ref37) {
  var className = _ref37.className,
      _ref37$width = _ref37.width,
      width = _ref37$width === undefined ? 32 : _ref37$width,
      _ref37$height = _ref37.height,
      height = _ref37$height === undefined ? 32 : _ref37$height,
      _ref37$strokeWidth = _ref37.strokeWidth,
      strokeWidth = _ref37$strokeWidth === undefined ? '6.25%' : _ref37$strokeWidth,
      _ref37$strokeLinejoin = _ref37.strokeLinejoin,
      strokeLinejoin = _ref37$strokeLinejoin === undefined ? 'round' : _ref37$strokeLinejoin,
      _ref37$strokeLinecap = _ref37.strokeLinecap,
      strokeLinecap = _ref37$strokeLinecap === undefined ? 'round' : _ref37$strokeLinecap,
      _ref37$color = _ref37.color,
      color = _ref37$color === undefined ? 'currentcolor' : _ref37$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-video',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M22 13 L30 8 30 24 22 19 Z M2 8 L2 24 22 24 22 8 Z'
  }));
};

var Music = exports.Music = function Music(_ref38) {
  var className = _ref38.className,
      _ref38$width = _ref38.width,
      width = _ref38$width === undefined ? 32 : _ref38$width,
      _ref38$height = _ref38.height,
      height = _ref38$height === undefined ? 32 : _ref38$height,
      _ref38$strokeWidth = _ref38.strokeWidth,
      strokeWidth = _ref38$strokeWidth === undefined ? '6.25%' : _ref38$strokeWidth,
      _ref38$strokeLinejoin = _ref38.strokeLinejoin,
      strokeLinejoin = _ref38$strokeLinejoin === undefined ? 'round' : _ref38$strokeLinejoin,
      _ref38$strokeLinecap = _ref38.strokeLinecap,
      strokeLinecap = _ref38$strokeLinecap === undefined ? 'round' : _ref38$strokeLinecap,
      _ref38$color = _ref38.color,
      color = _ref38$color === undefined ? 'currentcolor' : _ref38$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-music',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M11 25 L11 6 24 3 24 23 M11 13 L24 10'
  }), _react2.default.createElement('ellipse', {
    cx: '7',
    cy: '25',
    rx: '4',
    ry: '5'
  }), _react2.default.createElement('ellipse', {
    cx: '20',
    cy: '23',
    rx: '4',
    ry: '5'
  }));
};

var Mail = exports.Mail = function Mail(_ref39) {
  var className = _ref39.className,
      _ref39$width = _ref39.width,
      width = _ref39$width === undefined ? 32 : _ref39$width,
      _ref39$height = _ref39.height,
      height = _ref39$height === undefined ? 32 : _ref39$height,
      _ref39$strokeWidth = _ref39.strokeWidth,
      strokeWidth = _ref39$strokeWidth === undefined ? '6.25%' : _ref39$strokeWidth,
      _ref39$strokeLinejoin = _ref39.strokeLinejoin,
      strokeLinejoin = _ref39$strokeLinejoin === undefined ? 'round' : _ref39$strokeLinejoin,
      _ref39$strokeLinecap = _ref39.strokeLinecap,
      strokeLinecap = _ref39$strokeLinecap === undefined ? 'round' : _ref39$strokeLinecap,
      _ref39$color = _ref39.color,
      color = _ref39$color === undefined ? 'currentcolor' : _ref39$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-mail',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 26 L30 26 30 6 2 6 Z M2 6 L16 16 30 6'
  }));
};

var Home = exports.Home = function Home(_ref40) {
  var className = _ref40.className,
      _ref40$width = _ref40.width,
      width = _ref40$width === undefined ? 32 : _ref40$width,
      _ref40$height = _ref40.height,
      height = _ref40$height === undefined ? 32 : _ref40$height,
      _ref40$strokeWidth = _ref40.strokeWidth,
      strokeWidth = _ref40$strokeWidth === undefined ? '6.25%' : _ref40$strokeWidth,
      _ref40$strokeLinejoin = _ref40.strokeLinejoin,
      strokeLinejoin = _ref40$strokeLinejoin === undefined ? 'round' : _ref40$strokeLinejoin,
      _ref40$strokeLinecap = _ref40.strokeLinecap,
      strokeLinecap = _ref40$strokeLinecap === undefined ? 'round' : _ref40$strokeLinecap,
      _ref40$color = _ref40.color,
      color = _ref40$color === undefined ? 'currentcolor' : _ref40$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-home',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M12 20 L12 30 4 30 4 12 16 2 28 12 28 30 20 30 20 20 Z'
  }));
};

var User = exports.User = function User(_ref41) {
  var className = _ref41.className,
      _ref41$width = _ref41.width,
      width = _ref41$width === undefined ? 32 : _ref41$width,
      _ref41$height = _ref41.height,
      height = _ref41$height === undefined ? 32 : _ref41$height,
      _ref41$strokeWidth = _ref41.strokeWidth,
      strokeWidth = _ref41$strokeWidth === undefined ? '6.25%' : _ref41$strokeWidth,
      _ref41$strokeLinejoin = _ref41.strokeLinejoin,
      strokeLinejoin = _ref41$strokeLinejoin === undefined ? 'round' : _ref41$strokeLinejoin,
      _ref41$strokeLinecap = _ref41.strokeLinecap,
      strokeLinecap = _ref41$strokeLinecap === undefined ? 'round' : _ref41$strokeLinecap,
      _ref41$color = _ref41.color,
      color = _ref41$color === undefined ? 'currentcolor' : _ref41$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-user',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M22 11 C22 16 19 20 16 20 13 20 10 16 10 11 10 6 12 3 16 3 20 3 22 6 22 11 Z M4 30 L28 30 C28 21 22 20 16 20 10 20 4 21 4 30 Z'
  }));
};

var Trash = exports.Trash = function Trash(_ref42) {
  var className = _ref42.className,
      _ref42$width = _ref42.width,
      width = _ref42$width === undefined ? 32 : _ref42$width,
      _ref42$height = _ref42.height,
      height = _ref42$height === undefined ? 32 : _ref42$height,
      _ref42$strokeWidth = _ref42.strokeWidth,
      strokeWidth = _ref42$strokeWidth === undefined ? '6.25%' : _ref42$strokeWidth,
      _ref42$strokeLinejoin = _ref42.strokeLinejoin,
      strokeLinejoin = _ref42$strokeLinejoin === undefined ? 'round' : _ref42$strokeLinejoin,
      _ref42$strokeLinecap = _ref42.strokeLinecap,
      strokeLinecap = _ref42$strokeLinecap === undefined ? 'round' : _ref42$strokeLinecap,
      _ref42$color = _ref42.color,
      color = _ref42$color === undefined ? 'currentcolor' : _ref42$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-trash',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M28 6 L6 6 8 30 24 30 26 6 4 6 M16 12 L16 24 M21 12 L20 24 M11 12 L12 24 M12 6 L13 2 19 2 20 6'
  }));
};

var Paperclip = exports.Paperclip = function Paperclip(_ref43) {
  var className = _ref43.className,
      _ref43$width = _ref43.width,
      width = _ref43$width === undefined ? 32 : _ref43$width,
      _ref43$height = _ref43.height,
      height = _ref43$height === undefined ? 32 : _ref43$height,
      _ref43$strokeWidth = _ref43.strokeWidth,
      strokeWidth = _ref43$strokeWidth === undefined ? '6.25%' : _ref43$strokeWidth,
      _ref43$strokeLinejoin = _ref43.strokeLinejoin,
      strokeLinejoin = _ref43$strokeLinejoin === undefined ? 'round' : _ref43$strokeLinejoin,
      _ref43$strokeLinecap = _ref43.strokeLinecap,
      strokeLinecap = _ref43$strokeLinecap === undefined ? 'round' : _ref43$strokeLinecap,
      _ref43$color = _ref43.color,
      color = _ref43$color === undefined ? 'currentcolor' : _ref43$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-paperclip',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M10 9 L10 24 C10 28 13 30 16 30 19 30 22 28 22 24 L22 6 C22 3 20 2 18 2 16 2 14 3 14 6 L14 23 C14 24 15 25 16 25 17 25 18 24 18 23 L18 9'
  }));
};

var File = exports.File = function File(_ref44) {
  var className = _ref44.className,
      _ref44$width = _ref44.width,
      width = _ref44$width === undefined ? 32 : _ref44$width,
      _ref44$height = _ref44.height,
      height = _ref44$height === undefined ? 32 : _ref44$height,
      _ref44$strokeWidth = _ref44.strokeWidth,
      strokeWidth = _ref44$strokeWidth === undefined ? '6.25%' : _ref44$strokeWidth,
      _ref44$strokeLinejoin = _ref44.strokeLinejoin,
      strokeLinejoin = _ref44$strokeLinejoin === undefined ? 'round' : _ref44$strokeLinejoin,
      _ref44$strokeLinecap = _ref44.strokeLinecap,
      strokeLinecap = _ref44$strokeLinecap === undefined ? 'round' : _ref44$strokeLinecap,
      _ref44$color = _ref44.color,
      color = _ref44$color === undefined ? 'currentcolor' : _ref44$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-file',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M6 2 L6 30 26 30 26 10 18 2 Z M18 2 L18 10 26 10'
  }));
};

var Folder = exports.Folder = function Folder(_ref45) {
  var className = _ref45.className,
      _ref45$width = _ref45.width,
      width = _ref45$width === undefined ? 32 : _ref45$width,
      _ref45$height = _ref45.height,
      height = _ref45$height === undefined ? 32 : _ref45$height,
      _ref45$strokeWidth = _ref45.strokeWidth,
      strokeWidth = _ref45$strokeWidth === undefined ? '6.25%' : _ref45$strokeWidth,
      _ref45$strokeLinejoin = _ref45.strokeLinejoin,
      strokeLinejoin = _ref45$strokeLinejoin === undefined ? 'round' : _ref45$strokeLinejoin,
      _ref45$strokeLinecap = _ref45.strokeLinecap,
      strokeLinecap = _ref45$strokeLinecap === undefined ? 'round' : _ref45$strokeLinecap,
      _ref45$color = _ref45.color,
      color = _ref45$color === undefined ? 'currentcolor' : _ref45$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-folder',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 26 L30 26 30 7 14 7 10 4 2 4 Z M30 12 L2 12'
  }));
};

var FolderOpen = exports.FolderOpen = function FolderOpen(_ref46) {
  var className = _ref46.className,
      _ref46$width = _ref46.width,
      width = _ref46$width === undefined ? 32 : _ref46$width,
      _ref46$height = _ref46.height,
      height = _ref46$height === undefined ? 32 : _ref46$height,
      _ref46$strokeWidth = _ref46.strokeWidth,
      strokeWidth = _ref46$strokeWidth === undefined ? '6.25%' : _ref46$strokeWidth,
      _ref46$strokeLinejoin = _ref46.strokeLinejoin,
      strokeLinejoin = _ref46$strokeLinejoin === undefined ? 'round' : _ref46$strokeLinejoin,
      _ref46$strokeLinecap = _ref46.strokeLinecap,
      strokeLinecap = _ref46$strokeLinecap === undefined ? 'round' : _ref46$strokeLinecap,
      _ref46$color = _ref46.color,
      color = _ref46$color === undefined ? 'currentcolor' : _ref46$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-folder-open',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M4 28 L28 28 30 12 14 12 10 8 2 8 Z M28 12 L28 4 4 4 4 8'
  }));
};

var Work = exports.Work = function Work(_ref47) {
  var className = _ref47.className,
      _ref47$width = _ref47.width,
      width = _ref47$width === undefined ? 32 : _ref47$width,
      _ref47$height = _ref47.height,
      height = _ref47$height === undefined ? 32 : _ref47$height,
      _ref47$strokeWidth = _ref47.strokeWidth,
      strokeWidth = _ref47$strokeWidth === undefined ? '6.25%' : _ref47$strokeWidth,
      _ref47$strokeLinejoin = _ref47.strokeLinejoin,
      strokeLinejoin = _ref47$strokeLinejoin === undefined ? 'round' : _ref47$strokeLinejoin,
      _ref47$strokeLinecap = _ref47.strokeLinecap,
      strokeLinecap = _ref47$strokeLinecap === undefined ? 'round' : _ref47$strokeLinecap,
      _ref47$color = _ref47.color,
      color = _ref47$color === undefined ? 'currentcolor' : _ref47$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-work',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M30 8 L2 8 2 26 30 26 Z M20 8 C20 8 20 4 16 4 12 4 12 8 12 8 M8 26 L8 8 M24 26 L24 8'
  }));
};

var Portfolio = exports.Portfolio = function Portfolio(_ref48) {
  var className = _ref48.className,
      _ref48$width = _ref48.width,
      width = _ref48$width === undefined ? 32 : _ref48$width,
      _ref48$height = _ref48.height,
      height = _ref48$height === undefined ? 32 : _ref48$height,
      _ref48$strokeWidth = _ref48.strokeWidth,
      strokeWidth = _ref48$strokeWidth === undefined ? '6.25%' : _ref48$strokeWidth,
      _ref48$strokeLinejoin = _ref48.strokeLinejoin,
      strokeLinejoin = _ref48$strokeLinejoin === undefined ? 'round' : _ref48$strokeLinejoin,
      _ref48$strokeLinecap = _ref48.strokeLinecap,
      strokeLinecap = _ref48$strokeLinecap === undefined ? 'round' : _ref48$strokeLinecap,
      _ref48$color = _ref48.color,
      color = _ref48$color === undefined ? 'currentcolor' : _ref48$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-portfolio',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M29 17 L29 28 3 28 3 17 M2 8 L30 8 30 16 C30 16 24 20 16 20 8 20 2 16 2 16 L2 8 Z M16 22 L16 18 M20 8 C20 8 20 4 16 4 12 4 12 8 12 8'
  }));
};

var Book = exports.Book = function Book(_ref49) {
  var className = _ref49.className,
      _ref49$width = _ref49.width,
      width = _ref49$width === undefined ? 32 : _ref49$width,
      _ref49$height = _ref49.height,
      height = _ref49$height === undefined ? 32 : _ref49$height,
      _ref49$strokeWidth = _ref49.strokeWidth,
      strokeWidth = _ref49$strokeWidth === undefined ? '6.25%' : _ref49$strokeWidth,
      _ref49$strokeLinejoin = _ref49.strokeLinejoin,
      strokeLinejoin = _ref49$strokeLinejoin === undefined ? 'round' : _ref49$strokeLinejoin,
      _ref49$strokeLinecap = _ref49.strokeLinecap,
      strokeLinecap = _ref49$strokeLinecap === undefined ? 'round' : _ref49$strokeLinecap,
      _ref49$color = _ref49.color,
      color = _ref49$color === undefined ? 'currentcolor' : _ref49$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-book',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M16 7 C16 7 9 1 2 6 L2 28 C9 23 16 28 16 28 16 28 23 23 30 28 L30 6 C23 1 16 7 16 7 Z M16 7 L16 28'
  }));
};

var Calendar = exports.Calendar = function Calendar(_ref50) {
  var className = _ref50.className,
      _ref50$width = _ref50.width,
      width = _ref50$width === undefined ? 32 : _ref50$width,
      _ref50$height = _ref50.height,
      height = _ref50$height === undefined ? 32 : _ref50$height,
      _ref50$strokeWidth = _ref50.strokeWidth,
      strokeWidth = _ref50$strokeWidth === undefined ? '6.25%' : _ref50$strokeWidth,
      _ref50$strokeLinejoin = _ref50.strokeLinejoin,
      strokeLinejoin = _ref50$strokeLinejoin === undefined ? 'round' : _ref50$strokeLinejoin,
      _ref50$strokeLinecap = _ref50.strokeLinecap,
      strokeLinecap = _ref50$strokeLinecap === undefined ? 'round' : _ref50$strokeLinecap,
      _ref50$color = _ref50.color,
      color = _ref50$color === undefined ? 'currentcolor' : _ref50$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-calendar',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 6 L2 30 30 30 30 6 Z M2 15 L30 15 M7 3 L7 9 M13 3 L13 9 M19 3 L19 9 M25 3 L25 9'
  }));
};

var Print = exports.Print = function Print(_ref51) {
  var className = _ref51.className,
      _ref51$width = _ref51.width,
      width = _ref51$width === undefined ? 32 : _ref51$width,
      _ref51$height = _ref51.height,
      height = _ref51$height === undefined ? 32 : _ref51$height,
      _ref51$strokeWidth = _ref51.strokeWidth,
      strokeWidth = _ref51$strokeWidth === undefined ? '6.25%' : _ref51$strokeWidth,
      _ref51$strokeLinejoin = _ref51.strokeLinejoin,
      strokeLinejoin = _ref51$strokeLinejoin === undefined ? 'round' : _ref51$strokeLinejoin,
      _ref51$strokeLinecap = _ref51.strokeLinecap,
      strokeLinecap = _ref51$strokeLinecap === undefined ? 'round' : _ref51$strokeLinecap,
      _ref51$color = _ref51.color,
      color = _ref51$color === undefined ? 'currentcolor' : _ref51$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-print',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M7 25 L2 25 2 9 30 9 30 25 25 25 M7 19 L7 30 25 30 25 19 Z M25 9 L25 2 7 2 7 9 M22 14 L25 14'
  }));
};

var Eye = exports.Eye = function Eye(_ref52) {
  var className = _ref52.className,
      _ref52$width = _ref52.width,
      width = _ref52$width === undefined ? 32 : _ref52$width,
      _ref52$height = _ref52.height,
      height = _ref52$height === undefined ? 32 : _ref52$height,
      _ref52$strokeWidth = _ref52.strokeWidth,
      strokeWidth = _ref52$strokeWidth === undefined ? '6.25%' : _ref52$strokeWidth,
      _ref52$strokeLinejoin = _ref52.strokeLinejoin,
      strokeLinejoin = _ref52$strokeLinejoin === undefined ? 'round' : _ref52$strokeLinejoin,
      _ref52$strokeLinecap = _ref52.strokeLinecap,
      strokeLinecap = _ref52$strokeLinecap === undefined ? 'round' : _ref52$strokeLinecap,
      _ref52$color = _ref52.color,
      color = _ref52$color === undefined ? 'currentcolor' : _ref52$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-eye',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('circle', {
    cx: '17',
    cy: '15',
    r: '1'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '6'
  }), _react2.default.createElement('path', {
    d: 'M2 16 C2 16 7 6 16 6 25 6 30 16 30 16 30 16 25 26 16 26 7 26 2 16 2 16 Z'
  }));
};

var Bookmark = exports.Bookmark = function Bookmark(_ref53) {
  var className = _ref53.className,
      _ref53$width = _ref53.width,
      width = _ref53$width === undefined ? 32 : _ref53$width,
      _ref53$height = _ref53.height,
      height = _ref53$height === undefined ? 32 : _ref53$height,
      _ref53$strokeWidth = _ref53.strokeWidth,
      strokeWidth = _ref53$strokeWidth === undefined ? '6.25%' : _ref53$strokeWidth,
      _ref53$strokeLinejoin = _ref53.strokeLinejoin,
      strokeLinejoin = _ref53$strokeLinejoin === undefined ? 'round' : _ref53$strokeLinejoin,
      _ref53$strokeLinecap = _ref53.strokeLinecap,
      strokeLinecap = _ref53$strokeLinecap === undefined ? 'round' : _ref53$strokeLinecap,
      _ref53$color = _ref53.color,
      color = _ref53$color === undefined ? 'currentcolor' : _ref53$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-bookmark',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M6 2 L26 2 26 30 16 20 6 30 Z'
  }));
};

var Tag = exports.Tag = function Tag(_ref54) {
  var className = _ref54.className,
      _ref54$width = _ref54.width,
      width = _ref54$width === undefined ? 32 : _ref54$width,
      _ref54$height = _ref54.height,
      height = _ref54$height === undefined ? 32 : _ref54$height,
      _ref54$strokeWidth = _ref54.strokeWidth,
      strokeWidth = _ref54$strokeWidth === undefined ? '6.25%' : _ref54$strokeWidth,
      _ref54$strokeLinejoin = _ref54.strokeLinejoin,
      strokeLinejoin = _ref54$strokeLinejoin === undefined ? 'round' : _ref54$strokeLinejoin,
      _ref54$strokeLinecap = _ref54.strokeLinecap,
      strokeLinecap = _ref54$strokeLinecap === undefined ? 'round' : _ref54$strokeLinecap,
      _ref54$color = _ref54.color,
      color = _ref54$color === undefined ? 'currentcolor' : _ref54$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-tag',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('circle', {
    cx: '24',
    cy: '8',
    r: '2'
  }), _react2.default.createElement('path', {
    d: 'M2 18 L18 2 30 2 30 14 14 30 Z'
  }));
};

var Lightning = exports.Lightning = function Lightning(_ref55) {
  var className = _ref55.className,
      _ref55$width = _ref55.width,
      width = _ref55$width === undefined ? 32 : _ref55$width,
      _ref55$height = _ref55.height,
      height = _ref55$height === undefined ? 32 : _ref55$height,
      _ref55$strokeWidth = _ref55.strokeWidth,
      strokeWidth = _ref55$strokeWidth === undefined ? '6.25%' : _ref55$strokeWidth,
      _ref55$strokeLinejoin = _ref55.strokeLinejoin,
      strokeLinejoin = _ref55$strokeLinejoin === undefined ? 'round' : _ref55$strokeLinejoin,
      _ref55$strokeLinecap = _ref55.strokeLinecap,
      strokeLinecap = _ref55$strokeLinecap === undefined ? 'round' : _ref55$strokeLinecap,
      _ref55$color = _ref55.color,
      color = _ref55$color === undefined ? 'currentcolor' : _ref55$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-lightning',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M18 13 L26 2 8 13 14 19 6 30 24 19 Z'
  }));
};

var Activity = exports.Activity = function Activity(_ref56) {
  var className = _ref56.className,
      _ref56$width = _ref56.width,
      width = _ref56$width === undefined ? 32 : _ref56$width,
      _ref56$height = _ref56.height,
      height = _ref56$height === undefined ? 32 : _ref56$height,
      _ref56$strokeWidth = _ref56.strokeWidth,
      strokeWidth = _ref56$strokeWidth === undefined ? '6.25%' : _ref56$strokeWidth,
      _ref56$strokeLinejoin = _ref56.strokeLinejoin,
      strokeLinejoin = _ref56$strokeLinejoin === undefined ? 'round' : _ref56$strokeLinejoin,
      _ref56$strokeLinecap = _ref56.strokeLinecap,
      strokeLinecap = _ref56$strokeLinecap === undefined ? 'round' : _ref56$strokeLinecap,
      _ref56$color = _ref56.color,
      color = _ref56$color === undefined ? 'currentcolor' : _ref56$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-activity',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M4 16 L11 16 14 29 18 3 21 16 28 16'
  }));
};

var Location = exports.Location = function Location(_ref57) {
  var className = _ref57.className,
      _ref57$width = _ref57.width,
      width = _ref57$width === undefined ? 32 : _ref57$width,
      _ref57$height = _ref57.height,
      height = _ref57$height === undefined ? 32 : _ref57$height,
      _ref57$strokeWidth = _ref57.strokeWidth,
      strokeWidth = _ref57$strokeWidth === undefined ? '6.25%' : _ref57$strokeWidth,
      _ref57$strokeLinejoin = _ref57.strokeLinejoin,
      strokeLinejoin = _ref57$strokeLinejoin === undefined ? 'round' : _ref57$strokeLinejoin,
      _ref57$strokeLinecap = _ref57.strokeLinecap,
      strokeLinecap = _ref57$strokeLinecap === undefined ? 'round' : _ref57$strokeLinecap,
      _ref57$color = _ref57.color,
      color = _ref57$color === undefined ? 'currentcolor' : _ref57$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-location',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('circle', {
    cx: '16',
    cy: '11',
    r: '4'
  }), _react2.default.createElement('path', {
    d: 'M24 15 C21 22 16 30 16 30 16 30 11 22 8 15 5 8 10 2 16 2 22 2 27 8 24 15 Z'
  }));
};

var Export = exports.Export = function Export(_ref58) {
  var className = _ref58.className,
      _ref58$width = _ref58.width,
      width = _ref58$width === undefined ? 32 : _ref58$width,
      _ref58$height = _ref58.height,
      height = _ref58$height === undefined ? 32 : _ref58$height,
      _ref58$strokeWidth = _ref58.strokeWidth,
      strokeWidth = _ref58$strokeWidth === undefined ? '6.25%' : _ref58$strokeWidth,
      _ref58$strokeLinejoin = _ref58.strokeLinejoin,
      strokeLinejoin = _ref58$strokeLinejoin === undefined ? 'round' : _ref58$strokeLinejoin,
      _ref58$strokeLinecap = _ref58.strokeLinecap,
      strokeLinecap = _ref58$strokeLinecap === undefined ? 'round' : _ref58$strokeLinecap,
      _ref58$color = _ref58.color,
      color = _ref58$color === undefined ? 'currentcolor' : _ref58$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-export',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M28 22 L28 30 4 30 4 22 M16 4 L16 24 M8 12 L16 4 24 12'
  }));
};

var Import = exports.Import = function Import(_ref59) {
  var className = _ref59.className,
      _ref59$width = _ref59.width,
      width = _ref59$width === undefined ? 32 : _ref59$width,
      _ref59$height = _ref59.height,
      height = _ref59$height === undefined ? 32 : _ref59$height,
      _ref59$strokeWidth = _ref59.strokeWidth,
      strokeWidth = _ref59$strokeWidth === undefined ? '6.25%' : _ref59$strokeWidth,
      _ref59$strokeLinejoin = _ref59.strokeLinejoin,
      strokeLinejoin = _ref59$strokeLinejoin === undefined ? 'round' : _ref59$strokeLinejoin,
      _ref59$strokeLinecap = _ref59.strokeLinecap,
      strokeLinecap = _ref59$strokeLinecap === undefined ? 'round' : _ref59$strokeLinecap,
      _ref59$color = _ref59.color,
      color = _ref59$color === undefined ? 'currentcolor' : _ref59$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-import',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M28 22 L28 30 4 30 4 22 M16 4 L16 24 M8 16 L16 24 24 16'
  }));
};

var Inbox = exports.Inbox = function Inbox(_ref60) {
  var className = _ref60.className,
      _ref60$width = _ref60.width,
      width = _ref60$width === undefined ? 32 : _ref60$width,
      _ref60$height = _ref60.height,
      height = _ref60$height === undefined ? 32 : _ref60$height,
      _ref60$strokeWidth = _ref60.strokeWidth,
      strokeWidth = _ref60$strokeWidth === undefined ? '6.25%' : _ref60$strokeWidth,
      _ref60$strokeLinejoin = _ref60.strokeLinejoin,
      strokeLinejoin = _ref60$strokeLinejoin === undefined ? 'round' : _ref60$strokeLinejoin,
      _ref60$strokeLinecap = _ref60.strokeLinecap,
      strokeLinecap = _ref60$strokeLinecap === undefined ? 'round' : _ref60$strokeLinecap,
      _ref60$color = _ref60.color,
      color = _ref60$color === undefined ? 'currentcolor' : _ref60$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-inbox',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 15 L2 25 30 25 30 15 26 7 6 7 Z M2 15 L10 15 C10 15 11 20 16 20 21 20 22 15 22 15 L30 15'
  }));
};

var Archive = exports.Archive = function Archive(_ref61) {
  var className = _ref61.className,
      _ref61$width = _ref61.width,
      width = _ref61$width === undefined ? 32 : _ref61$width,
      _ref61$height = _ref61.height,
      height = _ref61$height === undefined ? 32 : _ref61$height,
      _ref61$strokeWidth = _ref61.strokeWidth,
      strokeWidth = _ref61$strokeWidth === undefined ? '6.25%' : _ref61$strokeWidth,
      _ref61$strokeLinejoin = _ref61.strokeLinejoin,
      strokeLinejoin = _ref61$strokeLinejoin === undefined ? 'round' : _ref61$strokeLinejoin,
      _ref61$strokeLinecap = _ref61.strokeLinecap,
      strokeLinecap = _ref61$strokeLinecap === undefined ? 'round' : _ref61$strokeLinecap,
      _ref61$color = _ref61.color,
      color = _ref61$color === undefined ? 'currentcolor' : _ref61$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-archive',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M4 10 L4 28 28 28 28 10 M2 4 L2 10 30 10 30 4 Z M12 15 L20 15'
  }));
};

var Reply = exports.Reply = function Reply(_ref62) {
  var className = _ref62.className,
      _ref62$width = _ref62.width,
      width = _ref62$width === undefined ? 32 : _ref62$width,
      _ref62$height = _ref62.height,
      height = _ref62$height === undefined ? 32 : _ref62$height,
      _ref62$strokeWidth = _ref62.strokeWidth,
      strokeWidth = _ref62$strokeWidth === undefined ? '6.25%' : _ref62$strokeWidth,
      _ref62$strokeLinejoin = _ref62.strokeLinejoin,
      strokeLinejoin = _ref62$strokeLinejoin === undefined ? 'round' : _ref62$strokeLinejoin,
      _ref62$strokeLinecap = _ref62.strokeLinecap,
      strokeLinecap = _ref62$strokeLinecap === undefined ? 'round' : _ref62$strokeLinecap,
      _ref62$color = _ref62.color,
      color = _ref62$color === undefined ? 'currentcolor' : _ref62$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-reply',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M10 6 L3 14 10 22 M3 14 L18 14 C26 14 30 18 30 26'
  }));
};

var Edit = exports.Edit = function Edit(_ref63) {
  var className = _ref63.className,
      _ref63$width = _ref63.width,
      width = _ref63$width === undefined ? 32 : _ref63$width,
      _ref63$height = _ref63.height,
      height = _ref63$height === undefined ? 32 : _ref63$height,
      _ref63$strokeWidth = _ref63.strokeWidth,
      strokeWidth = _ref63$strokeWidth === undefined ? '6.25%' : _ref63$strokeWidth,
      _ref63$strokeLinejoin = _ref63.strokeLinejoin,
      strokeLinejoin = _ref63$strokeLinejoin === undefined ? 'round' : _ref63$strokeLinejoin,
      _ref63$strokeLinecap = _ref63.strokeLinecap,
      strokeLinecap = _ref63$strokeLinecap === undefined ? 'round' : _ref63$strokeLinecap,
      _ref63$color = _ref63.color,
      color = _ref63$color === undefined ? 'currentcolor' : _ref63$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-edit',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M30 7 L25 2 5 22 3 29 10 27 Z M21 6 L26 11 Z M5 22 L10 27 Z'
  }));
};

var Compose = exports.Compose = function Compose(_ref64) {
  var className = _ref64.className,
      _ref64$width = _ref64.width,
      width = _ref64$width === undefined ? 32 : _ref64$width,
      _ref64$height = _ref64.height,
      height = _ref64$height === undefined ? 32 : _ref64$height,
      _ref64$strokeWidth = _ref64.strokeWidth,
      strokeWidth = _ref64$strokeWidth === undefined ? '6.25%' : _ref64$strokeWidth,
      _ref64$strokeLinejoin = _ref64.strokeLinejoin,
      strokeLinejoin = _ref64$strokeLinejoin === undefined ? 'round' : _ref64$strokeLinejoin,
      _ref64$strokeLinecap = _ref64.strokeLinecap,
      strokeLinecap = _ref64$strokeLinecap === undefined ? 'round' : _ref64$strokeLinecap,
      _ref64$color = _ref64.color,
      color = _ref64$color === undefined ? 'currentcolor' : _ref64$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-compose',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M27 15 L27 30 2 30 2 5 17 5 M30 6 L26 2 9 19 7 25 13 23 Z M22 6 L26 10 Z M9 19 L13 23 Z'
  }));
};

var Upload = exports.Upload = function Upload(_ref65) {
  var className = _ref65.className,
      _ref65$width = _ref65.width,
      width = _ref65$width === undefined ? 32 : _ref65$width,
      _ref65$height = _ref65.height,
      height = _ref65$height === undefined ? 32 : _ref65$height,
      _ref65$strokeWidth = _ref65.strokeWidth,
      strokeWidth = _ref65$strokeWidth === undefined ? '6.25%' : _ref65$strokeWidth,
      _ref65$strokeLinejoin = _ref65.strokeLinejoin,
      strokeLinejoin = _ref65$strokeLinejoin === undefined ? 'round' : _ref65$strokeLinejoin,
      _ref65$strokeLinecap = _ref65.strokeLinecap,
      strokeLinecap = _ref65$strokeLinecap === undefined ? 'round' : _ref65$strokeLinecap,
      _ref65$color = _ref65.color,
      color = _ref65$color === undefined ? 'currentcolor' : _ref65$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-upload',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M9 22 C0 23 1 12 9 13 6 2 23 2 22 10 32 7 32 23 23 22 M11 18 L16 14 21 18 M16 14 L16 29'
  }));
};

var Download = exports.Download = function Download(_ref66) {
  var className = _ref66.className,
      _ref66$width = _ref66.width,
      width = _ref66$width === undefined ? 32 : _ref66$width,
      _ref66$height = _ref66.height,
      height = _ref66$height === undefined ? 32 : _ref66$height,
      _ref66$strokeWidth = _ref66.strokeWidth,
      strokeWidth = _ref66$strokeWidth === undefined ? '6.25%' : _ref66$strokeWidth,
      _ref66$strokeLinejoin = _ref66.strokeLinejoin,
      strokeLinejoin = _ref66$strokeLinejoin === undefined ? 'round' : _ref66$strokeLinejoin,
      _ref66$strokeLinecap = _ref66.strokeLinecap,
      strokeLinecap = _ref66$strokeLinecap === undefined ? 'round' : _ref66$strokeLinecap,
      _ref66$color = _ref66.color,
      color = _ref66$color === undefined ? 'currentcolor' : _ref66$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-download',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M9 22 C0 23 1 12 9 13 6 2 23 2 22 10 32 7 32 23 23 22 M11 26 L16 30 21 26 M16 16 L16 30'
  }));
};

var Send = exports.Send = function Send(_ref67) {
  var className = _ref67.className,
      _ref67$width = _ref67.width,
      width = _ref67$width === undefined ? 32 : _ref67$width,
      _ref67$height = _ref67.height,
      height = _ref67$height === undefined ? 32 : _ref67$height,
      _ref67$strokeWidth = _ref67.strokeWidth,
      strokeWidth = _ref67$strokeWidth === undefined ? '6.25%' : _ref67$strokeWidth,
      _ref67$strokeLinejoin = _ref67.strokeLinejoin,
      strokeLinejoin = _ref67$strokeLinejoin === undefined ? 'round' : _ref67$strokeLinejoin,
      _ref67$strokeLinecap = _ref67.strokeLinecap,
      strokeLinecap = _ref67$strokeLinecap === undefined ? 'round' : _ref67$strokeLinecap,
      _ref67$color = _ref67.color,
      color = _ref67$color === undefined ? 'currentcolor' : _ref67$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-send',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 16 L30 2 16 30 12 20 Z M30 2 L12 20'
  }));
};

var Link = exports.Link = function Link(_ref68) {
  var className = _ref68.className,
      _ref68$width = _ref68.width,
      width = _ref68$width === undefined ? 32 : _ref68$width,
      _ref68$height = _ref68.height,
      height = _ref68$height === undefined ? 32 : _ref68$height,
      _ref68$strokeWidth = _ref68.strokeWidth,
      strokeWidth = _ref68$strokeWidth === undefined ? '6.25%' : _ref68$strokeWidth,
      _ref68$strokeLinejoin = _ref68.strokeLinejoin,
      strokeLinejoin = _ref68$strokeLinejoin === undefined ? 'round' : _ref68$strokeLinejoin,
      _ref68$strokeLinecap = _ref68.strokeLinecap,
      strokeLinecap = _ref68$strokeLinecap === undefined ? 'round' : _ref68$strokeLinecap,
      _ref68$color = _ref68.color,
      color = _ref68$color === undefined ? 'currentcolor' : _ref68$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-link',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M18 8 C18 8 24 2 27 5 30 8 29 12 24 16 19 20 16 21 14 17 M14 24 C14 24 8 30 5 27 2 24 3 20 8 16 13 12 16 11 18 15'
  }));
};

var Code = exports.Code = function Code(_ref69) {
  var className = _ref69.className,
      _ref69$width = _ref69.width,
      width = _ref69$width === undefined ? 32 : _ref69$width,
      _ref69$height = _ref69.height,
      height = _ref69$height === undefined ? 32 : _ref69$height,
      _ref69$strokeWidth = _ref69.strokeWidth,
      strokeWidth = _ref69$strokeWidth === undefined ? '6.25%' : _ref69$strokeWidth,
      _ref69$strokeLinejoin = _ref69.strokeLinejoin,
      strokeLinejoin = _ref69$strokeLinejoin === undefined ? 'round' : _ref69$strokeLinejoin,
      _ref69$strokeLinecap = _ref69.strokeLinecap,
      strokeLinecap = _ref69$strokeLinecap === undefined ? 'round' : _ref69$strokeLinecap,
      _ref69$color = _ref69.color,
      color = _ref69$color === undefined ? 'currentcolor' : _ref69$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-code',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M10 9 L3 17 10 25 M22 9 L29 17 22 25 M18 7 L14 27'
  }));
};

var Lock = exports.Lock = function Lock(_ref70) {
  var className = _ref70.className,
      _ref70$width = _ref70.width,
      width = _ref70$width === undefined ? 32 : _ref70$width,
      _ref70$height = _ref70.height,
      height = _ref70$height === undefined ? 32 : _ref70$height,
      _ref70$strokeWidth = _ref70.strokeWidth,
      strokeWidth = _ref70$strokeWidth === undefined ? '6.25%' : _ref70$strokeWidth,
      _ref70$strokeLinejoin = _ref70.strokeLinejoin,
      strokeLinejoin = _ref70$strokeLinejoin === undefined ? 'round' : _ref70$strokeLinejoin,
      _ref70$strokeLinecap = _ref70.strokeLinecap,
      strokeLinecap = _ref70$strokeLinecap === undefined ? 'round' : _ref70$strokeLinecap,
      _ref70$color = _ref70.color,
      color = _ref70$color === undefined ? 'currentcolor' : _ref70$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-lock',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M5 15 L5 30 27 30 27 15 Z M9 15 C9 9 9 5 16 5 23 5 23 9 23 15 M16 20 L16 23'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '24',
    r: '1'
  }));
};

var Unlock = exports.Unlock = function Unlock(_ref71) {
  var className = _ref71.className,
      _ref71$width = _ref71.width,
      width = _ref71$width === undefined ? 32 : _ref71$width,
      _ref71$height = _ref71.height,
      height = _ref71$height === undefined ? 32 : _ref71$height,
      _ref71$strokeWidth = _ref71.strokeWidth,
      strokeWidth = _ref71$strokeWidth === undefined ? '6.25%' : _ref71$strokeWidth,
      _ref71$strokeLinejoin = _ref71.strokeLinejoin,
      strokeLinejoin = _ref71$strokeLinejoin === undefined ? 'round' : _ref71$strokeLinejoin,
      _ref71$strokeLinecap = _ref71.strokeLinecap,
      strokeLinecap = _ref71$strokeLinecap === undefined ? 'round' : _ref71$strokeLinecap,
      _ref71$color = _ref71.color,
      color = _ref71$color === undefined ? 'currentcolor' : _ref71$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-unlock',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M5 15 L5 30 27 30 27 15 Z M9 15 C9 7 9 3 16 3 23 3 23 8 23 9 M16 20 L16 23'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '24',
    r: '1'
  }));
};

var Bell = exports.Bell = function Bell(_ref72) {
  var className = _ref72.className,
      _ref72$width = _ref72.width,
      width = _ref72$width === undefined ? 32 : _ref72$width,
      _ref72$height = _ref72.height,
      height = _ref72$height === undefined ? 32 : _ref72$height,
      _ref72$strokeWidth = _ref72.strokeWidth,
      strokeWidth = _ref72$strokeWidth === undefined ? '6.25%' : _ref72$strokeWidth,
      _ref72$strokeLinejoin = _ref72.strokeLinejoin,
      strokeLinejoin = _ref72$strokeLinejoin === undefined ? 'round' : _ref72$strokeLinejoin,
      _ref72$strokeLinecap = _ref72.strokeLinecap,
      strokeLinecap = _ref72$strokeLinecap === undefined ? 'round' : _ref72$strokeLinecap,
      _ref72$color = _ref72.color,
      color = _ref72$color === undefined ? 'currentcolor' : _ref72$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-bell',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M8 17 C8 12 9 6 16 6 23 6 24 12 24 17 24 22 27 25 27 25 L5 25 C5 25 8 22 8 17 Z M20 25 C20 25 20 29 16 29 12 29 12 25 12 25 M16 3 L16 6'
  }));
};

var Alert = exports.Alert = function Alert(_ref73) {
  var className = _ref73.className,
      _ref73$width = _ref73.width,
      width = _ref73$width === undefined ? 32 : _ref73$width,
      _ref73$height = _ref73.height,
      height = _ref73$height === undefined ? 32 : _ref73$height,
      _ref73$strokeWidth = _ref73.strokeWidth,
      strokeWidth = _ref73$strokeWidth === undefined ? '6.25%' : _ref73$strokeWidth,
      _ref73$strokeLinejoin = _ref73.strokeLinejoin,
      strokeLinejoin = _ref73$strokeLinejoin === undefined ? 'round' : _ref73$strokeLinejoin,
      _ref73$strokeLinecap = _ref73.strokeLinecap,
      strokeLinecap = _ref73$strokeLinecap === undefined ? 'round' : _ref73$strokeLinecap,
      _ref73$color = _ref73.color,
      color = _ref73$color === undefined ? 'currentcolor' : _ref73$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-alert',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M16 3 L30 29 2 29 Z M16 11 L16 19 M16 23 L16 25'
  }));
};

var Info = exports.Info = function Info(_ref74) {
  var className = _ref74.className,
      _ref74$width = _ref74.width,
      width = _ref74$width === undefined ? 32 : _ref74$width,
      _ref74$height = _ref74.height,
      height = _ref74$height === undefined ? 32 : _ref74$height,
      _ref74$strokeWidth = _ref74.strokeWidth,
      strokeWidth = _ref74$strokeWidth === undefined ? '6.25%' : _ref74$strokeWidth,
      _ref74$strokeLinejoin = _ref74.strokeLinejoin,
      strokeLinejoin = _ref74$strokeLinejoin === undefined ? 'round' : _ref74$strokeLinejoin,
      _ref74$strokeLinecap = _ref74.strokeLinecap,
      strokeLinecap = _ref74$strokeLinecap === undefined ? 'round' : _ref74$strokeLinecap,
      _ref74$color = _ref74.color,
      color = _ref74$color === undefined ? 'currentcolor' : _ref74$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-info',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M16 14 L16 23 M16 8 L16 10'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '14'
  }));
};

var CreditCard = exports.CreditCard = function CreditCard(_ref75) {
  var className = _ref75.className,
      _ref75$width = _ref75.width,
      width = _ref75$width === undefined ? 32 : _ref75$width,
      _ref75$height = _ref75.height,
      height = _ref75$height === undefined ? 32 : _ref75$height,
      _ref75$strokeWidth = _ref75.strokeWidth,
      strokeWidth = _ref75$strokeWidth === undefined ? '6.25%' : _ref75$strokeWidth,
      _ref75$strokeLinejoin = _ref75.strokeLinejoin,
      strokeLinejoin = _ref75$strokeLinejoin === undefined ? 'round' : _ref75$strokeLinejoin,
      _ref75$strokeLinecap = _ref75.strokeLinecap,
      strokeLinecap = _ref75$strokeLinecap === undefined ? 'round' : _ref75$strokeLinecap,
      _ref75$color = _ref75.color,
      color = _ref75$color === undefined ? 'currentcolor' : _ref75$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-creditcard',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M2 7 L2 25 30 25 30 7 Z M5 18 L9 18 M5 21 L11 21'
  }), _react2.default.createElement('path', {
    d: 'M2 11 L2 13 30 13 30 11 Z',
    fill: 'currentColor'
  }));
};

var Cart = exports.Cart = function Cart(_ref76) {
  var className = _ref76.className,
      _ref76$width = _ref76.width,
      width = _ref76$width === undefined ? 32 : _ref76$width,
      _ref76$height = _ref76.height,
      height = _ref76$height === undefined ? 32 : _ref76$height,
      _ref76$strokeWidth = _ref76.strokeWidth,
      strokeWidth = _ref76$strokeWidth === undefined ? '6.25%' : _ref76$strokeWidth,
      _ref76$strokeLinejoin = _ref76.strokeLinejoin,
      strokeLinejoin = _ref76$strokeLinejoin === undefined ? 'round' : _ref76$strokeLinejoin,
      _ref76$strokeLinecap = _ref76.strokeLinecap,
      strokeLinecap = _ref76$strokeLinecap === undefined ? 'round' : _ref76$strokeLinecap,
      _ref76$color = _ref76.color,
      color = _ref76$color === undefined ? 'currentcolor' : _ref76$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-cart',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M6 6 L30 6 27 19 9 19 M27 23 L10 23 5 2 2 2'
  }), _react2.default.createElement('circle', {
    cx: '25',
    cy: '27',
    r: '2'
  }), _react2.default.createElement('circle', {
    cx: '12',
    cy: '27',
    r: '2'
  }));
};

var Gift = exports.Gift = function Gift(_ref77) {
  var className = _ref77.className,
      _ref77$width = _ref77.width,
      width = _ref77$width === undefined ? 32 : _ref77$width,
      _ref77$height = _ref77.height,
      height = _ref77$height === undefined ? 32 : _ref77$height,
      _ref77$strokeWidth = _ref77.strokeWidth,
      strokeWidth = _ref77$strokeWidth === undefined ? '6.25%' : _ref77$strokeWidth,
      _ref77$strokeLinejoin = _ref77.strokeLinejoin,
      strokeLinejoin = _ref77$strokeLinejoin === undefined ? 'round' : _ref77$strokeLinejoin,
      _ref77$strokeLinecap = _ref77.strokeLinecap,
      strokeLinecap = _ref77$strokeLinecap === undefined ? 'round' : _ref77$strokeLinecap,
      _ref77$color = _ref77.color,
      color = _ref77$color === undefined ? 'currentcolor' : _ref77$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-gift',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M4 14 L4 30 28 30 28 14 M2 9 L2 14 30 14 30 9 Z M16 9 C 16 9 14 0 8 3 2 6 16 9 16 9 16 9 18 0 24 3 30 6 16 9 16 9 M16 9 L16 30'
  }));
};

var External = exports.External = function External(_ref78) {
  var className = _ref78.className,
      _ref78$width = _ref78.width,
      width = _ref78$width === undefined ? 32 : _ref78$width,
      _ref78$height = _ref78.height,
      height = _ref78$height === undefined ? 32 : _ref78$height,
      _ref78$strokeWidth = _ref78.strokeWidth,
      strokeWidth = _ref78$strokeWidth === undefined ? '6.25%' : _ref78$strokeWidth,
      _ref78$strokeLinejoin = _ref78.strokeLinejoin,
      strokeLinejoin = _ref78$strokeLinejoin === undefined ? 'round' : _ref78$strokeLinejoin,
      _ref78$strokeLinecap = _ref78.strokeLinecap,
      strokeLinecap = _ref78$strokeLinecap === undefined ? 'round' : _ref78$strokeLinecap,
      _ref78$color = _ref78.color,
      color = _ref78$color === undefined ? 'currentcolor' : _ref78$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-external',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M14 9 L3 9 3 29 23 29 23 18 M18 4 L28 4 28 14 M28 4 L14 18'
  }));
};

var Reload = exports.Reload = function Reload(_ref79) {
  var className = _ref79.className,
      _ref79$width = _ref79.width,
      width = _ref79$width === undefined ? 32 : _ref79$width,
      _ref79$height = _ref79.height,
      height = _ref79$height === undefined ? 32 : _ref79$height,
      _ref79$strokeWidth = _ref79.strokeWidth,
      strokeWidth = _ref79$strokeWidth === undefined ? '6.25%' : _ref79$strokeWidth,
      _ref79$strokeLinejoin = _ref79.strokeLinejoin,
      strokeLinejoin = _ref79$strokeLinejoin === undefined ? 'round' : _ref79$strokeLinejoin,
      _ref79$strokeLinecap = _ref79.strokeLinecap,
      strokeLinecap = _ref79$strokeLinecap === undefined ? 'round' : _ref79$strokeLinecap,
      _ref79$color = _ref79.color,
      color = _ref79$color === undefined ? 'currentcolor' : _ref79$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-reload',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M29 16 C29 22 24 29 16 29 8 29 3 22 3 16 3 10 8 3 16 3 21 3 25 6 27 9 M20 10 L27 9 28 2'
  }));
};

var EllipsisHorizontal = exports.EllipsisHorizontal = function EllipsisHorizontal(_ref80) {
  var className = _ref80.className,
      _ref80$width = _ref80.width,
      width = _ref80$width === undefined ? 32 : _ref80$width,
      _ref80$height = _ref80.height,
      height = _ref80$height === undefined ? 32 : _ref80$height,
      _ref80$strokeWidth = _ref80.strokeWidth,
      strokeWidth = _ref80$strokeWidth === undefined ? '6.25%' : _ref80$strokeWidth,
      _ref80$strokeLinejoin = _ref80.strokeLinejoin,
      strokeLinejoin = _ref80$strokeLinejoin === undefined ? 'round' : _ref80$strokeLinejoin,
      _ref80$strokeLinecap = _ref80.strokeLinecap,
      strokeLinecap = _ref80$strokeLinecap === undefined ? 'round' : _ref80$strokeLinecap,
      _ref80$color = _ref80.color,
      color = _ref80$color === undefined ? 'currentcolor' : _ref80$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-ellipsis-horizontal',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('circle', {
    cx: '7',
    cy: '16',
    r: '2'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }), _react2.default.createElement('circle', {
    cx: '25',
    cy: '16',
    r: '2'
  }));
};

var EllipsisVertical = exports.EllipsisVertical = function EllipsisVertical(_ref81) {
  var className = _ref81.className,
      _ref81$width = _ref81.width,
      width = _ref81$width === undefined ? 32 : _ref81$width,
      _ref81$height = _ref81.height,
      height = _ref81$height === undefined ? 32 : _ref81$height,
      _ref81$strokeWidth = _ref81.strokeWidth,
      strokeWidth = _ref81$strokeWidth === undefined ? '6.25%' : _ref81$strokeWidth,
      _ref81$strokeLinejoin = _ref81.strokeLinejoin,
      strokeLinejoin = _ref81$strokeLinejoin === undefined ? 'round' : _ref81$strokeLinejoin,
      _ref81$strokeLinecap = _ref81.strokeLinecap,
      strokeLinecap = _ref81$strokeLinecap === undefined ? 'round' : _ref81$strokeLinecap,
      _ref81$color = _ref81.color,
      color = _ref81$color === undefined ? 'currentcolor' : _ref81$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-ellipsis-vertical',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('circle', {
    cx: '16',
    cy: '7',
    r: '2'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '16',
    r: '2'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '25',
    r: '2'
  }));
};

var Twitter = exports.Twitter = function Twitter(_ref82) {
  var className = _ref82.className,
      _ref82$width = _ref82.width,
      width = _ref82$width === undefined ? 32 : _ref82$width,
      _ref82$height = _ref82.height,
      height = _ref82$height === undefined ? 32 : _ref82$height,
      _ref82$color = _ref82.color,
      color = _ref82$color === undefined ? 'currentcolor' : _ref82$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-twitter',
    viewBox: '0 0 64 64',
    width: width,
    height: height
  }, _react2.default.createElement('path', {
    strokeWidth: '0',
    fill: color,
    d: 'M60 16 L54 17 L58 12 L51 14 C42 4 28 15 32 24 C16 24 8 12 8 12 C8 12 2 21 12 28 L6 26 C6 32 10 36 17 38 L10 38 C14 46 21 46 21 46 C21 46 15 51 4 51 C37 67 57 37 54 21 Z'
  }));
};

var GitHub = exports.GitHub = function GitHub(_ref83) {
  var className = _ref83.className,
      _ref83$width = _ref83.width,
      width = _ref83$width === undefined ? 32 : _ref83$width,
      _ref83$height = _ref83.height,
      height = _ref83$height === undefined ? 32 : _ref83$height,
      _ref83$color = _ref83.color,
      color = _ref83$color === undefined ? 'currentcolor' : _ref83$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-github',
    viewBox: '0 0 64 64',
    width: width,
    height: height
  }, _react2.default.createElement('path', {
    strokeWidth: '0',
    fill: color,
    d: 'M32 0 C14 0 0 14 0 32 0 53 19 62 22 62 24 62 24 61 24 60 L24 55 C17 57 14 53 13 50 13 50 13 49 11 47 10 46 6 44 10 44 13 44 15 48 15 48 18 52 22 51 24 50 24 48 26 46 26 46 18 45 12 42 12 31 12 27 13 24 15 22 15 22 13 18 15 13 15 13 20 13 24 17 27 15 37 15 40 17 44 13 49 13 49 13 51 20 49 22 49 22 51 24 52 27 52 31 52 42 45 45 38 46 39 47 40 49 40 52 L40 60 C40 61 40 62 42 62 45 62 64 53 64 32 64 14 50 0 32 0 Z'
  }));
};

var Bag = exports.Bag = function Bag(_ref84) {
  var className = _ref84.className,
      _ref84$width = _ref84.width,
      width = _ref84$width === undefined ? 32 : _ref84$width,
      _ref84$height = _ref84.height,
      height = _ref84$height === undefined ? 32 : _ref84$height,
      _ref84$strokeWidth = _ref84.strokeWidth,
      strokeWidth = _ref84$strokeWidth === undefined ? '6.25%' : _ref84$strokeWidth,
      _ref84$strokeLinejoin = _ref84.strokeLinejoin,
      strokeLinejoin = _ref84$strokeLinejoin === undefined ? 'round' : _ref84$strokeLinejoin,
      _ref84$strokeLinecap = _ref84.strokeLinecap,
      strokeLinecap = _ref84$strokeLinecap === undefined ? 'round' : _ref84$strokeLinecap,
      _ref84$color = _ref84.color,
      color = _ref84$color === undefined ? 'currentcolor' : _ref84$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-bag',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M5 9 L5 29 27 29 27 9 Z M10 9 C10 9 10 3 16 3 22 3 22 9 22 9'
  }));
};

var Clipboard = exports.Clipboard = function Clipboard(_ref85) {
  var className = _ref85.className,
      _ref85$width = _ref85.width,
      width = _ref85$width === undefined ? 32 : _ref85$width,
      _ref85$height = _ref85.height,
      height = _ref85$height === undefined ? 32 : _ref85$height,
      _ref85$strokeWidth = _ref85.strokeWidth,
      strokeWidth = _ref85$strokeWidth === undefined ? '6.25%' : _ref85$strokeWidth,
      _ref85$strokeLinejoin = _ref85.strokeLinejoin,
      strokeLinejoin = _ref85$strokeLinejoin === undefined ? 'round' : _ref85$strokeLinejoin,
      _ref85$strokeLinecap = _ref85.strokeLinecap,
      strokeLinecap = _ref85$strokeLinecap === undefined ? 'round' : _ref85$strokeLinecap,
      _ref85$color = _ref85.color,
      color = _ref85$color === undefined ? 'currentcolor' : _ref85$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-clipboard',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4'
  }));
};

var Desktop = exports.Desktop = function Desktop(_ref86) {
  var className = _ref86.className,
      _ref86$width = _ref86.width,
      width = _ref86$width === undefined ? 32 : _ref86$width,
      _ref86$height = _ref86.height,
      height = _ref86$height === undefined ? 32 : _ref86$height,
      _ref86$strokeWidth = _ref86.strokeWidth,
      strokeWidth = _ref86$strokeWidth === undefined ? '6.25%' : _ref86$strokeWidth,
      _ref86$strokeLinejoin = _ref86.strokeLinejoin,
      strokeLinejoin = _ref86$strokeLinejoin === undefined ? 'round' : _ref86$strokeLinejoin,
      _ref86$strokeLinecap = _ref86.strokeLinecap,
      strokeLinecap = _ref86$strokeLinecap === undefined ? 'round' : _ref86$strokeLinecap,
      _ref86$color = _ref86.color,
      color = _ref86$color === undefined ? 'currentcolor' : _ref86$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-desktop',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M10 29 C10 29 10 24 16 24 22 24 22 29 22 29 L10 29 Z M2 6 L2 23 30 23 30 6 2 6 Z'
  }));
};

var Fire = exports.Fire = function Fire(_ref87) {
  var className = _ref87.className,
      _ref87$width = _ref87.width,
      width = _ref87$width === undefined ? 32 : _ref87$width,
      _ref87$height = _ref87.height,
      height = _ref87$height === undefined ? 32 : _ref87$height,
      _ref87$strokeWidth = _ref87.strokeWidth,
      strokeWidth = _ref87$strokeWidth === undefined ? '6.25%' : _ref87$strokeWidth,
      _ref87$strokeLinejoin = _ref87.strokeLinejoin,
      strokeLinejoin = _ref87$strokeLinejoin === undefined ? 'round' : _ref87$strokeLinejoin,
      _ref87$strokeLinecap = _ref87.strokeLinecap,
      strokeLinecap = _ref87$strokeLinecap === undefined ? 'round' : _ref87$strokeLinecap,
      _ref87$color = _ref87.color,
      color = _ref87$color === undefined ? 'currentcolor' : _ref87$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-fire',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M15 30 C0 30 15 13 12 3 28 13 32 30 15 30 Z M17 30 C10 30 17 20 17 20 17 20 24 30 17 30 Z'
  }));
};

var Microphone = exports.Microphone = function Microphone(_ref88) {
  var className = _ref88.className,
      _ref88$width = _ref88.width,
      width = _ref88$width === undefined ? 32 : _ref88$width,
      _ref88$height = _ref88.height,
      height = _ref88$height === undefined ? 32 : _ref88$height,
      _ref88$strokeWidth = _ref88.strokeWidth,
      strokeWidth = _ref88$strokeWidth === undefined ? '6.25%' : _ref88$strokeWidth,
      _ref88$strokeLinejoin = _ref88.strokeLinejoin,
      strokeLinejoin = _ref88$strokeLinejoin === undefined ? 'round' : _ref88$strokeLinejoin,
      _ref88$strokeLinecap = _ref88.strokeLinecap,
      strokeLinecap = _ref88$strokeLinecap === undefined ? 'round' : _ref88$strokeLinecap,
      _ref88$color = _ref88.color,
      color = _ref88$color === undefined ? 'currentcolor' : _ref88$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-microphone',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M16 2 C12 2 12 6 12 6 L12 16 C12 16 12 20 16 20 20 20 20 16 20 16 L20 6 C20 6 20 2 16 2 Z M8 17 C8 17 8 24 16 24 24 24 24 17 24 17 M13 29 L19 29 M16 24 L16 29'
  }));
};

var Mobile = exports.Mobile = function Mobile(_ref89) {
  var className = _ref89.className,
      _ref89$width = _ref89.width,
      width = _ref89$width === undefined ? 32 : _ref89$width,
      _ref89$height = _ref89.height,
      height = _ref89$height === undefined ? 32 : _ref89$height,
      _ref89$strokeWidth = _ref89.strokeWidth,
      strokeWidth = _ref89$strokeWidth === undefined ? '6.25%' : _ref89$strokeWidth,
      _ref89$strokeLinejoin = _ref89.strokeLinejoin,
      strokeLinejoin = _ref89$strokeLinejoin === undefined ? 'round' : _ref89$strokeLinejoin,
      _ref89$strokeLinecap = _ref89.strokeLinecap,
      strokeLinecap = _ref89$strokeLinecap === undefined ? 'round' : _ref89$strokeLinecap,
      _ref89$color = _ref89.color,
      color = _ref89$color === undefined ? 'currentcolor' : _ref89$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-mobile',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M21 2 L11 2 C10 2 9 3 9 4 L9 28 C9 29 10 30 11 30 L21 30 C22 30 23 29 23 28 L23 4 C23 3 22 2 21 2 Z M9 5 L23 5 M9 27 L23 27'
  }));
};

var Move = exports.Move = function Move(_ref90) {
  var className = _ref90.className,
      _ref90$width = _ref90.width,
      width = _ref90$width === undefined ? 32 : _ref90$width,
      _ref90$height = _ref90.height,
      height = _ref90$height === undefined ? 32 : _ref90$height,
      _ref90$strokeWidth = _ref90.strokeWidth,
      strokeWidth = _ref90$strokeWidth === undefined ? '6.25%' : _ref90$strokeWidth,
      _ref90$strokeLinejoin = _ref90.strokeLinejoin,
      strokeLinejoin = _ref90$strokeLinejoin === undefined ? 'round' : _ref90$strokeLinejoin,
      _ref90$strokeLinecap = _ref90.strokeLinecap,
      strokeLinecap = _ref90$strokeLinecap === undefined ? 'round' : _ref90$strokeLinecap,
      _ref90$color = _ref90.color,
      color = _ref90$color === undefined ? 'currentcolor' : _ref90$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-move',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M3 16 L29 16 M16 3 L16 29 M12 7 L16 3 20 7 M12 25 L16 29 20 25 M25 12 L29 16 25 20 M7 12 L3 16 7 20'
  }));
};

var Telephone = exports.Telephone = function Telephone(_ref91) {
  var className = _ref91.className,
      _ref91$width = _ref91.width,
      width = _ref91$width === undefined ? 32 : _ref91$width,
      _ref91$height = _ref91.height,
      height = _ref91$height === undefined ? 32 : _ref91$height,
      _ref91$strokeWidth = _ref91.strokeWidth,
      strokeWidth = _ref91$strokeWidth === undefined ? '6.25%' : _ref91$strokeWidth,
      _ref91$strokeLinejoin = _ref91.strokeLinejoin,
      strokeLinejoin = _ref91$strokeLinejoin === undefined ? 'round' : _ref91$strokeLinejoin,
      _ref91$strokeLinecap = _ref91.strokeLinecap,
      strokeLinecap = _ref91$strokeLinecap === undefined ? 'round' : _ref91$strokeLinecap,
      _ref91$color = _ref91.color,
      color = _ref91$color === undefined ? 'currentcolor' : _ref91$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-telephone',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M3 12 C3 5 10 5 16 5 22 5 29 5 29 12 29 20 22 11 22 11 L10 11 C10 11 3 20 3 12 Z M11 14 C11 14 6 19 6 28 L26 28 C26 19 21 14 21 14 L11 14 Z'
  }), _react2.default.createElement('circle', {
    cx: '16',
    cy: '21',
    r: '4'
  }));
};

var SignIn = exports.SignIn = function SignIn(_ref92) {
  var className = _ref92.className,
      _ref92$width = _ref92.width,
      width = _ref92$width === undefined ? 32 : _ref92$width,
      _ref92$height = _ref92.height,
      height = _ref92$height === undefined ? 32 : _ref92$height,
      _ref92$strokeWidth = _ref92.strokeWidth,
      strokeWidth = _ref92$strokeWidth === undefined ? '6.25%' : _ref92$strokeWidth,
      _ref92$strokeLinejoin = _ref92.strokeLinejoin,
      strokeLinejoin = _ref92$strokeLinejoin === undefined ? 'round' : _ref92$strokeLinejoin,
      _ref92$strokeLinecap = _ref92.strokeLinecap,
      strokeLinecap = _ref92$strokeLinecap === undefined ? 'round' : _ref92$strokeLinecap,
      _ref92$color = _ref92.color,
      color = _ref92$color === undefined ? 'currentcolor' : _ref92$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-signin',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M3 16 L23 16 M15 8 L23 16 15 24 M21 4 L29 4 29 28 21 28'
  }));
};

var SignOut = exports.SignOut = function SignOut(_ref93) {
  var className = _ref93.className,
      _ref93$width = _ref93.width,
      width = _ref93$width === undefined ? 32 : _ref93$width,
      _ref93$height = _ref93.height,
      height = _ref93$height === undefined ? 32 : _ref93$height,
      _ref93$strokeWidth = _ref93.strokeWidth,
      strokeWidth = _ref93$strokeWidth === undefined ? '6.25%' : _ref93$strokeWidth,
      _ref93$strokeLinejoin = _ref93.strokeLinejoin,
      strokeLinejoin = _ref93$strokeLinejoin === undefined ? 'round' : _ref93$strokeLinejoin,
      _ref93$strokeLinecap = _ref93.strokeLinecap,
      strokeLinecap = _ref93$strokeLinecap === undefined ? 'round' : _ref93$strokeLinecap,
      _ref93$color = _ref93.color,
      color = _ref93$color === undefined ? 'currentcolor' : _ref93$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-signout',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M28 16 L8 16 M20 8 L28 16 20 24 M11 28 L3 28 3 4 11 4'
  }));
};

var Heart = exports.Heart = function Heart(_ref94) {
  var className = _ref94.className,
      _ref94$width = _ref94.width,
      width = _ref94$width === undefined ? 32 : _ref94$width,
      _ref94$height = _ref94.height,
      height = _ref94$height === undefined ? 32 : _ref94$height,
      _ref94$strokeWidth = _ref94.strokeWidth,
      strokeWidth = _ref94$strokeWidth === undefined ? '6.25%' : _ref94$strokeWidth,
      _ref94$strokeLinejoin = _ref94.strokeLinejoin,
      strokeLinejoin = _ref94$strokeLinejoin === undefined ? 'round' : _ref94$strokeLinejoin,
      _ref94$strokeLinecap = _ref94.strokeLinecap,
      strokeLinecap = _ref94$strokeLinecap === undefined ? 'round' : _ref94$strokeLinecap,
      _ref94$color = _ref94.color,
      color = _ref94$color === undefined ? 'currentcolor' : _ref94$color;
  return _react2.default.createElement('svg', {
    className: className,
    id: 'i-heart',
    viewBox: '0 0 32 32',
    width: width,
    height: height,
    fill: 'none',
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, _react2.default.createElement('path', {
    d: 'M4 16 C1 12 2 6 7 4 12 2 15 6 16 8 17 6 21 2 26 4 31 6 31 12 28 16 25 20 16 28 16 28 16 28 7 20 4 16 Z'
  }));
};